var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path8, _path9, _path10, _polygon, _polygon2, _rect46, _rect47, _rect48, _polygon3, _polygon4, _polygon5, _rect49, _rect50, _path11, _path12, _circle, _circle2, _polyline, _ellipse, _path13, _path14, _path15, _path16, _path17, _rect51, _rect52, _path18, _path19, _path20, _rect53, _rect54, _path21, _path22, _path23, _path24, _path25, _polygon6, _path26, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _rect55, _rect56, _polygon12, _rect57, _rect58, _rect59, _path27, _path28, _g, _g2, _path29, _rect60, _rect61, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g3, _rect62, _rect63, _rect64, _rect65, _path59, _path60, _path61, _path62, _path63, _path64, _polygon13, _rect66, _rect67, _rect68, _rect69, _path65, _path66, _path67, _path68, _path69, _path70, _rect70, _path71, _path72, _g4, _g5, _path73, _rect71, _rect72, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _rect73, _path74, _path75, _g6, _g7, _path76, _rect74, _rect75, _path77, _path78, _g8, _rect76, _path79, _path80, _g9, _g10, _path81, _rect77, _rect78, _path82, _path83, _path84, _g11, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g12, _path114, _g13, _path115, _path116, _path117, _path118, _path119, _polygon24, _polygon25, _rect79, _path120, _path121, _g14, _g15, _rect80, _rect81, _rect82, _circle3, _circle4, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _polygon26, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _polygon27, _polygon28, _path147, _path148, _path149, _path150, _polygon29, _polygon30, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _polygon31, _path159, _path160, _rect83, _rect84, _path161, _path162, _path163, _path164, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 372.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#f5f5f5;}.c,.g{fill:#f0f0f0;}.d{fill:#e6e6e6;}.e{fill:#e0e0e0;}.f,.i,.k,.l,.m,.o,.p,.u,.w,.x{fill:#fff;}.g{stroke:#e0e0e0;stroke-width:2px;}.g,.r,.s{stroke-linecap:round;stroke-linejoin:round;}.h{fill:#263238;}.i{opacity:0.5;}.af,.j,.o{opacity:0.2;}.aa,.ae,.k,.x{opacity:0.6;}.l{opacity:0.8;}.m,.t{opacity:0.7;}.n{fill:#407bff;}.p,.q{opacity:0.4;}.r,.s{fill:none;stroke:#000;}.r{stroke-width:0.33px;stroke-dasharray:7.65 1.53 22.95 3.06;}.s{stroke-width:0.35px;stroke-dasharray:6.1 1.22 18.31 2.44;}.u,.v{opacity:0.3;}.w{opacity:0.1;}.x,.y{isolation:isolate;}.z{opacity:0.25;}.ab{fill:#b97964;}.ac{fill:#b97864;}.ad{fill:#a24e3f;}.ae{fill:#fafafa;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    y: 327.4,
    width: 500,
    height: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 416.8,
    y: 343.5,
    width: 33.1,
    height: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 322.5,
    y: 346.3,
    width: 8.7,
    height: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 396.6,
    y: 334.3,
    width: 19.2,
    height: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 52.5,
    y: 335.9,
    width: 43.2,
    height: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 104.6,
    y: 335.9,
    width: 6.3,
    height: 0.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 131.5,
    y: 340.2,
    width: 93.7,
    height: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M237,337.8H43.9a5.8,5.8,0,0,1-5.7-5.7V60.7A5.7,5.7,0,0,1,43.9,55H237a5.6,5.6,0,0,1,5.7,5.7V332.1A5.7,5.7,0,0,1,237,337.8ZM43.9,55.2a5.5,5.5,0,0,0-5.4,5.5V332.1a5.4,5.4,0,0,0,5.4,5.4H237a5.5,5.5,0,0,0,5.5-5.4V60.7a5.5,5.5,0,0,0-5.5-5.5Z",
    transform: "translate(0 -55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.3,337.8H260.2a5.8,5.8,0,0,1-5.7-5.7V60.7a5.7,5.7,0,0,1,5.7-5.7H453.3a5.6,5.6,0,0,1,5.7,5.7V332.1A5.7,5.7,0,0,1,453.3,337.8ZM260.2,55.2a5.5,5.5,0,0,0-5.4,5.5V332.1a5.4,5.4,0,0,0,5.4,5.4H453.3a5.5,5.5,0,0,0,5.5-5.4V60.7a5.5,5.5,0,0,0-5.5-5.5Z",
    transform: "translate(0 -55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.7,375.1H214l-11.7-95.6a8.5,8.5,0,0,0-8.2-7.3H96.6l14.3,102.9Z",
    transform: "translate(0 -55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M120.9,375.1H98.5L86.8,279.5a6.3,6.3,0,0,1,6.4-7.3h7.7a8.5,8.5,0,0,1,8.2,7.3Z",
    transform: "translate(0 -55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M129.1,375,125,328.8a4.2,4.2,0,0,0-3.8-4l-1.7-.2a6,6,0,0,1-5.1-5.4l-.7-8.4a5.9,5.9,0,0,1,5.9-6.5H82.2a6,6,0,0,0-5.9,6.5l.8,8.4a6,6,0,0,0,5.1,5.4l1.7.2a4.4,4.4,0,0,1,3.8,4L91.8,375a6.5,6.5,0,0,0,6.5,6h37.3A6.5,6.5,0,0,1,129.1,375Z",
    transform: "translate(0 -55)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M231.8,317.2a14,14,0,0,1,14-12.9H213.3a14,14,0,0,0-14,12.9l-3.2,36.6h32.5Z",
    transform: "translate(0 -55)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.3,304.3H245.8a14,14,0,0,0-14,12.9l-3.2,36.6H151.2L148,317.2a14,14,0,0,0-14-12.9H119.6a5.9,5.9,0,0,0-5.9,6.5l.7,8.4a6,6,0,0,0,5.1,5.4l1.7.2a4.2,4.2,0,0,1,3.8,4l4.1,46.2a6.5,6.5,0,0,0,6.5,6H244.2a6.5,6.5,0,0,0,6.5-6l4.1-46.2a4.2,4.2,0,0,1,3.8-4l1.7-.2a6,6,0,0,0,5.1-5.4l.7-8.4A5.9,5.9,0,0,0,260.3,304.3Z",
    transform: "translate(0 -55)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 280.6,
    y: 135.2,
    width: 150.7,
    height: 190.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 285.9,
    y: 142.2,
    width: 140,
    height: 40.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 285.9,
    y: 148.8,
    width: 8,
    height: 34.19
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 324.4,
    y: 148.8,
    width: 8,
    height: 34.19
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 371,
    y: 203.3,
    width: 8,
    height: 34.19,
    transform: "translate(-32 11.9) rotate(-9.8)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 295.8,
    y: 153.3,
    width: 8,
    height: 29.69
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 314.1,
    y: 153.3,
    width: 8,
    height: 29.69
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 360.2,
    y: 153.3,
    width: 8,
    height: 29.69
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 338.1,
    y: 207.7,
    width: 8,
    height: 29.69,
    transform: "translate(-40.1 24.6) rotate(-12.5)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 306.6,
    y: 147.1,
    width: 4,
    height: 35.89
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 353.9,
    y: 147.1,
    width: 4,
    height: 35.89
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 285.9,
    y: 244.4,
    width: 140,
    height: 40.8,
    transform: "translate(711.9 474.6) rotate(180)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 418,
    y: 251,
    width: 8,
    height: 34.19,
    transform: "translate(843.9 481.2) rotate(180)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 379.5,
    y: 251,
    width: 8,
    height: 34.19,
    transform: "translate(767 481.2) rotate(180)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 332.9,
    y: 250.6,
    width: 8,
    height: 34.19,
    transform: "translate(623.4 533.7) rotate(-170.2)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 408.1,
    y: 255.5,
    width: 8,
    height: 29.69,
    transform: "translate(824.2 485.7) rotate(180)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 389.9,
    y: 255.5,
    width: 8,
    height: 29.69,
    transform: "translate(787.7 485.7) rotate(180)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 343.7,
    y: 255.5,
    width: 8,
    height: 29.69,
    transform: "translate(695.4 485.7) rotate(180)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 365.8,
    y: 255,
    width: 8,
    height: 29.69,
    transform: "translate(672.2 558.5) rotate(-167.5)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 401.3,
    y: 249.3,
    width: 4,
    height: 35.89,
    transform: "translate(806.5 479.5) rotate(180)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 353.9,
    y: 249.3,
    width: 4,
    height: 35.89,
    transform: "translate(711.9 479.5) rotate(180)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 285.9,
    y: 196,
    width: 8,
    height: 34.19
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 295.8,
    y: 200.6,
    width: 8,
    height: 29.69
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 314.1,
    y: 200.6,
    width: 8,
    height: 29.69
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 306.6,
    y: 194.3,
    width: 4,
    height: 35.89
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 285.9,
    y: 236.7,
    width: 140,
    height: 40.8
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 366.3,
    y: 243.3,
    width: 8,
    height: 34.19
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 412.9,
    y: 297.8,
    width: 8,
    height: 34.19,
    transform: "translate(-47.4 20.4) rotate(-9.8)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 337.7,
    y: 247.8,
    width: 8,
    height: 29.69
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 356,
    y: 247.8,
    width: 8,
    height: 29.69
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 402.1,
    y: 247.8,
    width: 8,
    height: 29.69
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 380.1,
    y: 302.3,
    width: 8,
    height: 29.69,
    transform: "translate(-59.6 35.9) rotate(-12.5)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 348.5,
    y: 241.6,
    width: 4,
    height: 35.89
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 395.9,
    y: 241.6,
    width: 4,
    height: 35.89
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 321.4,
    y: 297.8,
    width: 8,
    height: 34.19,
    transform: "translate(-48.8 4.9) rotate(-9.8)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 310.6,
    y: 247.8,
    width: 8,
    height: 29.69
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 288.5,
    y: 302.3,
    width: 8,
    height: 29.69,
    transform: "translate(-61.8 16) rotate(-12.5)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 304.3,
    y: 241.6,
    width: 4,
    height: 35.89
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M303.7,190.2v-2.9h4.6a53.3,53.3,0,0,1-1.7-26.8s0,11.7,4.5,11.8c6.9.1,7.5-11.8,7.5-11.8s1.6,17.1-4.6,26.8h4.8v2.9Z",
    transform: "translate(0 -55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M316.6,168.3a4,4,0,1,1-4-4A4,4,0,0,1,316.6,168.3Z",
    transform: "translate(0 -55)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M334.5,190.2v-1.7l4.9-2.2-2.5-2.4,6.1-21.3v13.3s-.9,0-.9,1.9,2.8,1.5,2.8-.1-.9-1.8-.9-1.8V162l5.5,21.1-2.5,3.2,5,2.2v1.7Z",
    transform: "translate(0 -55)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "364.2 135.2 364.2 133.9 368.7 132.9 368.7 113.3 372.5 108 375.8 112.2 375.8 121.2 377.4 118.8 379.8 117.9 381.5 121.6 377.9 132.9 381.5 133.9 381.5 135.2 364.2 135.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "393.8 135.8 399.3 108 416.1 108 412.1 123.8 418 135.2 393.8 135.8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 67.8,
    y: 68.2,
    width: 135.4,
    height: 5.39,
    rx: 1.8
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 75.8,
    y: 72.5,
    width: 119.3,
    height: 105.84
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 78.8,
    y: 75.4,
    width: 113.2,
    height: 100.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "105.4 75.4 78.8 175.3 78.8 128.4 92.9 75.4 105.4 75.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "114.8 75.4 88 175.5 83.7 175.5 110.5 75.4 114.8 75.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "192 138.6 192 154.6 186.6 175.5 182.3 175.5 192 138.6"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 116.4,
    y: 73.6,
    width: 1.9,
    height: 104.13
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 153.3,
    y: 73.6,
    width: 1.9,
    height: 104.13
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M175.7,124.9s2.7,35.8,18.5,54.1c0,0-11.5,46-11.5,62.1l21.4-3.9-7.7-58,3.7-54.3Z",
    transform: "translate(0 -55)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M95.3,124.9S92.5,160.7,76.8,179c0,0,11.5,46,11.4,62.1l-21.3-3.9,7.7-58-3.7-54.3Z",
    transform: "translate(0 -55)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 355.9,
    cy: 55.1,
    r: 14.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 355.9,
    cy: 55.1,
    r: 12
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "g",
    points: "356.5 46.8 356.5 55.2 362.1 52.1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 250,
    cy: 361.3,
    rx: 193.9,
    ry: 11.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M132.8,364.9c3.5,8.4,46.9,4.9,46.9,4.9s-17.3-17.7-32.2-18.8S132.8,364.9,132.8,364.9Z",
    transform: "translate(0 -55)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M132.8,364.9c3.5,8.4,46.9,4.9,46.9,4.9s-17.3-17.7-32.2-18.8S132.8,364.9,132.8,364.9Z",
    transform: "translate(0 -55)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M132.8,364.9c3.5,8.4,46.9,4.9,46.9,4.9s-17.3-17.7-32.2-18.8S132.8,364.9,132.8,364.9Z",
    transform: "translate(0 -55)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M154.8,369.8s-.7,1.6,46,1.6H331v-3.5Z",
    transform: "translate(0 -55)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M154.8,369.8s-.7,1.6,46,1.6H331v-3.5Z",
    transform: "translate(0 -55)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 154.8,
    y: 72.8,
    width: 177.5,
    height: 242.06
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 154.8,
    y: 72.8,
    width: 177.5,
    height: 242.06
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M154.8,127.8s-3.3-8.7-14.2-7.4-9.6,9.1-9.6,9.1l1.8,235.4s1.4-7.7,12.7-4.2c8.3,2.6,9.3,9.1,9.3,9.1S158.2,152.8,154.8,127.8Z",
    transform: "translate(0 -55)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M154.8,127.8s-3.3-8.7-14.2-7.4-9.6,9.1-9.6,9.1l1.8,235.4s1.4-7.7,12.7-4.2c8.3,2.6,9.3,9.1,9.3,9.1S158.2,152.8,154.8,127.8Z",
    transform: "translate(0 -55)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M174.5,294.2a1.8,1.8,0,0,0,0-3.6h-.2V290h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.8,1.7,1.7,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,1,0,0-3.6h-.2V249h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.6h.2a1.7,1.7,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.5h.2a1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.7,1.7,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,1,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.7v.2a1.8,1.8,0,0,0,3.6,0v-.2h.7v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.7,1.7,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.7h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.7,1.7,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.7,1.7,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8v.3H242v-.3a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.8,1.7,1.7,0,0,0-1.7,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-3.6,0c0,.1.1.2.1.3h-.6v-.3a1.8,1.8,0,1,0-3.6,0,.4.4,0,0,0,.1.3h-.7a.4.4,0,0,0,.1-.3,1.8,1.8,0,1,0-3.6,0,.4.4,0,0,0,.1.3h-.7c0-.1.1-.2.1-.3a1.8,1.8,0,0,0-3.6,0v.3h-.6c0-.1.1-.2.1-.3a1.8,1.8,0,0,0-3.6,0v.3h-.6v-.3a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3H205v-.3a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.8,1.7,1.7,0,0,0-1.7,1.8v.3h-.6v-.3a1.8,1.8,0,1,0-3.6,0c0,.1.1.2.1.3h-.6v-.3a1.8,1.8,0,0,0-3.6,0,.4.4,0,0,0,.1.3h-.7a.4.4,0,0,0,.1-.3,1.8,1.8,0,0,0-3.6,0,.4.4,0,0,0,.1.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.8h-.2v-.6Z",
    transform: "translate(0 -55)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 177.7,
    y: 174.9,
    width: 63.5,
    height: 63.48
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 177.7,
    y: 174.9,
    width: 63.5,
    height: 63.48
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.5,261l-1.1,1.4s.5,5.3-2.4,4.5l.2,5.2-.8.7v9.8h-9.6l.3-4.3h-1l.5-4.4-.5-.2-.4-5.8-.7-.3.7-3.7-.3-2.6.3-1.2-.9-5-1-1.5.4-1.5a47.5,47.5,0,0,1-.3-5.4l-.3-4.5h-.3V241s-.9-.4-.2-1.3V239l-1.1-.7v-.9h1a1.2,1.2,0,0,1-.2-1.4c.4-.8,1.8-.6,2-1.6a2.4,2.4,0,0,1,.5,2.3h0a1.2,1.2,0,0,1-.5.7h.9v.9l-1,.7v.7a1.8,1.8,0,0,1,0,1.4,13.5,13.5,0,0,0,.4,2.6,11.2,11.2,0,0,1,.4,2.4s.3.2,1,3.2h.7l.3,1.8,1.3,1v-1.6h-.3V250l-1-.2.9-.4v-.5l-1.5-.7h2.1l-1.1-1.6,1.8,1.2.4-.2.2-2.6.6,2.8h.6l1.6-1.1-.9,1.6.3.2,2.1-.4-1.6,1.1v.4l1.6.5h-1.5a2,2,0,0,1-.3,1.9v1l.6.3v.6l1.6,1c.1.1,1.3,3.6,1.4,3.7a5.7,5.7,0,0,0,1.4-.4s-.1-.6.8-.9,1.2-.2,1.2.5h.5Z",
    transform: "translate(0 -55)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M207.5,261l-1.1,1.4s.5,5.3-2.4,4.5l.2,5.2-.8.7v9.8h-9.6l.3-4.3h-1l.5-4.4-.5-.2-.4-5.8-.7-.3.7-3.7-.3-2.6.3-1.2-.9-5-1-1.5.4-1.5a47.5,47.5,0,0,1-.3-5.4l-.3-4.5h-.3V241s-.9-.4-.2-1.3V239l-1.1-.7v-.9h1a1.2,1.2,0,0,1-.2-1.4c.4-.8,1.8-.6,2-1.6a2.4,2.4,0,0,1,.5,2.3h0a1.2,1.2,0,0,1-.5.7h.9v.9l-1,.7v.7a1.8,1.8,0,0,1,0,1.4,13.5,13.5,0,0,0,.4,2.6,11.2,11.2,0,0,1,.4,2.4s.3.2,1,3.2h.7l.3,1.8,1.3,1v-1.6h-.3V250l-1-.2.9-.4v-.5l-1.5-.7h2.1l-1.1-1.6,1.8,1.2.4-.2.2-2.6.6,2.8h.6l1.6-1.1-.9,1.6.3.2,2.1-.4-1.6,1.1v.4l1.6.5h-1.5a2,2,0,0,1-.3,1.9v1l.6.3v.6l1.6,1c.1.1,1.3,3.6,1.4,3.7a5.7,5.7,0,0,0,1.4-.4s-.1-.6.8-.9,1.2-.2,1.2.5h.5Z",
    transform: "translate(0 -55)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M192.7,265.8l6-9.9.7,1.2s-1.9,5.8-2,7.5,2-4.5,2-4.5l1.4,2.6s-.8,5.9,0,6.3,1.1-4.7,1.1-4.7l.8,1.5.7,6.2a13.5,13.5,0,0,1-2.9,0c-.8-.3-2.1,3-3.2,2.6s-3.1,3.2-3.1,3.2v-4.1s2.6-2.7,3.1-5l-3.7,4.2-.3-5,1.2-1.7-1.9.8Z",
    transform: "translate(0 -55)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M195.8,250s1.2-1.8,3.5,0c0,0-.6-1.8-1.9-1.8S195.8,250,195.8,250Z",
    transform: "translate(0 -55)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M196.3,250a2,2,0,0,1,2.3,0v.4a2.8,2.8,0,0,0-1-.1c-.3,0-.2,1-.2,1h-.3a3.3,3.3,0,0,0,0-1c-.2-.1-.8.1-.8.1Z",
    transform: "translate(0 -55)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "193.5 195.4 191.2 198.1 192 199.2 192.7 198.3 192.7 201.1 193.3 203 194.4 201 193.3 204.9 195.2 202.9 193.2 206.4 193.8 207.8 197.8 201.6 197.1 201.2 195.5 202.3 195.5 200.5 194.7 200.5 194.7 198.2 193.8 197.7 193.2 198.6 193.6 196.8 193.5 195.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M192.3,236.7h0a1.2,1.2,0,0,1-1,.6c.3-.2.2-.7.2-.7a1.3,1.3,0,0,1-.9.7.7.7,0,0,1-.4-.7c-.4.3-.3.8-.2.8a1.2,1.2,0,0,1-.2-1.4c.4-.8,1.8-.6,2-1.6A2.4,2.4,0,0,1,192.3,236.7Z",
    transform: "translate(0 -55)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "203.8 225.9 193.1 225.9 190.3 227.7 190.3 228.9 206.6 228.9 206.6 227.7 203.8 225.9"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "p",
    points: "203.8 225.9 193.1 225.9 190.3 227.7 190.3 228.9 206.6 228.9 206.6 227.7 203.8 225.9"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "191 227.7 205.7 227.7 203.8 225.9 193.1 225.9 191 227.7"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "209.5 231.1 209.5 232.2 209.1 232.2 209.1 233.3 208 233.3 208 238.4 188.5 238.4 188.5 233.3 187.4 233.3 187.4 232.2 187 232.2 187 231.1 189 231.1 189 228.3 207.5 228.3 207.5 231.1 209.5 231.1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "209.5 231.1 209.5 232.2 209.1 232.2 209.1 233.3 208 233.3 208 238.4 188.5 238.4 188.5 233.3 187.4 233.3 187.4 232.2 187 232.2 187 231.1 189 231.1 189 228.3 207.5 228.3 207.5 231.1 209.5 231.1"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 187.4,
    y: 232.2,
    width: 21.8,
    height: 0.3
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 188.5,
    y: 233.3,
    width: 19.4,
    height: 1.42
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "199 231.1 207.5 231.1 207.5 230.6 199 230.6 199 229.5 197.4 229.5 197.4 230.6 189 230.6 189 231.1 197.4 231.1 199 231.1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 193.6,
    y: 236.1,
    width: 2.4,
    height: 2.32
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 197,
    y: 236.1,
    width: 2.4,
    height: 2.32
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 200.4,
    y: 236.1,
    width: 2.4,
    height: 2.32
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.7,241.6c0,3.1-1.7,4.8-4.2,4.8a4.8,4.8,0,0,1-2.2-.5l.4-.8a3.4,3.4,0,0,0,1.8.4c1.9,0,3.2-1.2,3.2-3.7V241a3.1,3.1,0,0,1-2.8,1.6c-1.9,0-3.1-1.1-3.1-2.7a2.8,2.8,0,0,1,3.1-2.8C226.3,237.1,227.7,238.7,227.7,241.6Zm-1.3-1.8c0-1-.9-1.9-2.5-1.9s-2.2.7-2.2,1.9a2,2,0,0,0,2.3,2A2.2,2.2,0,0,0,226.4,239.8Z",
    transform: "translate(0 -55)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M229,241.7c0-2.9,1.5-4.6,3.7-4.6s3.6,1.7,3.6,4.6-1.5,4.7-3.6,4.7S229,244.6,229,241.7Zm6.3,0c0-2.4-1.1-3.8-2.6-3.8s-2.7,1.4-2.7,3.8,1.1,3.8,2.7,3.8S235.3,244.1,235.3,241.7Z",
    transform: "translate(0 -55)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M223,275.3a11.2,11.2,0,1,1-13.9-7.6A11.3,11.3,0,0,1,223,275.3Z",
    transform: "translate(0 -55)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M218.7,284.6a8.9,8.9,0,0,1-12.6.4,9,9,0,0,1-.3-12.7,8.9,8.9,0,1,1,12.9,12.3Z",
    transform: "translate(0 -55)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M281.1,351.8v.3h.5v-.3a1.8,1.8,0,0,1,1.8-1.7h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.7h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.7h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.7h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.8,1.7,1.7,0,0,1,1.8-1.7h.2v-.6h-.2a1.8,1.8,0,1,1,0-3.6h.2V329h-.2a1.8,1.8,0,1,1,0-3.6h.2v-.7h-.2a1.8,1.8,0,1,1,0-3.6h.2v-.7h-.2a1.8,1.8,0,1,1,0-3.6h.2v-.6h-.2a1.8,1.8,0,1,1,0-3.6h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.7,1.8,1.8,0,0,1,1.8-1.8h.2v-.6h-.2a1.8,1.8,0,0,1-1.8-1.7,1.8,1.8,0,0,1,1.8-1.8h.2v-.6h-.2a1.7,1.7,0,0,1-1.8-1.7v-.2H281v.2a1.7,1.7,0,0,1-1.7,1.7,1.7,1.7,0,0,1-1.8-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.7,1.7,1.7,1.7,0,0,1-1.8-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.7,1.7,0,0,1-1.7-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.7,1.7,0,0,1-1.7-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.6,1.6,0,0,1-1.7-1.7v-.2h-.6v.2a1.8,1.8,0,0,1-3.6,0,.3.3,0,0,1,.1-.2h-.6v.2a1.8,1.8,0,0,1-3.6,0c0-.1,0-.2.1-.2h-.7c.1,0,.1.1.1.2a1.8,1.8,0,0,1-3.6,0c0-.1,0-.2.1-.2h-.7a.3.3,0,0,1,.1.2,1.8,1.8,0,0,1-3.6,0v-.2H244a.3.3,0,0,1,.1.2,1.8,1.8,0,0,1-3.6,0v-.2h-.6v.2a1.7,1.7,0,0,1-1.7,1.7,1.7,1.7,0,0,1-1.8-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.7,1.7,1.7,1.7,0,0,1-1.8-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.7,1.7,1.7,1.7,0,0,1-1.8-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.7,1.7,0,0,1-1.7-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.7,1.7,0,0,1-1.7-1.7v-.2h-.6v.2a1.7,1.7,0,0,1-1.8,1.7,1.6,1.6,0,0,1-1.7-1.7v-.2h-.6a.3.3,0,0,1,.1.2,1.7,1.7,0,0,1-1.8,1.7h-.3v.6h.3a1.8,1.8,0,0,1,0,3.6h-.3v.6h.3a1.8,1.8,0,0,1,0,3.6h-.3v.7h.3a1.8,1.8,0,1,1,0,3.6h-.3v.6h.3a1.8,1.8,0,1,1,0,3.6h-.3v.6h.3a1.7,1.7,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.7h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.7h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.7h-.3v.6h.3a1.8,1.8,0,0,1,1.8,1.7c0,.1-.1.2-.1.3h.6v-.3a1.8,1.8,0,0,1,3.6,0,.4.4,0,0,1-.1.3h.7a.4.4,0,0,1-.1-.3,1.8,1.8,0,0,1,3.6,0v.3h.6c0-.1-.1-.2-.1-.3a1.8,1.8,0,0,1,3.6,0v.3h.6v-.3a1.7,1.7,0,0,1,1.7-1.7,1.8,1.8,0,0,1,1.8,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.7-1.7,1.8,1.8,0,0,1,1.8,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.7-1.7,1.8,1.8,0,0,1,1.8,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.8-1.7,1.8,1.8,0,0,1,1.7,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.8-1.7,1.8,1.8,0,0,1,1.7,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.8-1.7,1.8,1.8,0,0,1,1.7,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.8-1.7,1.7,1.7,0,0,1,1.7,1.7v.3h.6v-.3a1.8,1.8,0,0,1,3.6,0c0,.1-.1.2-.1.3h.6v-.3a1.8,1.8,0,0,1,3.6,0,.4.4,0,0,1-.1.3h.7a.4.4,0,0,1-.1-.3,1.8,1.8,0,0,1,3.6,0v.3h.6c0-.1-.1-.2-.1-.3a1.8,1.8,0,0,1,3.6,0v.3h.6v-.3a1.7,1.7,0,0,1,1.7-1.7,1.8,1.8,0,0,1,1.8,1.7v.3h.6v-.3a1.8,1.8,0,0,1,1.7-1.7A1.8,1.8,0,0,1,281.1,351.8Z",
    transform: "translate(0 -55)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 227.1,
    y: 295.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(575.7 23.8) rotate(90)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 227.1,
    y: 295.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(575.7 23.8) rotate(90)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,329.7h0c-.1-.1-.1-.1,0-.1l17.8-20.3h.1l-17.8,20.3Z",
    transform: "translate(0 -55)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,331.6h0c-.1-.1-.1-.1,0-.2l18-21.2h.1v.2l-18,21.2A.1.1,0,0,1,217.3,331.6Z",
    transform: "translate(0 -55)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,333.5h0c-.1,0-.1,0,0-.1L235.4,311h.1c.1,0,.1.1,0,.1l-18.1,22.3Z",
    transform: "translate(0 -55)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,335.3h0c-.1,0-.1-.1,0-.1l18.3-23.4h.1l-18.3,23.4Z",
    transform: "translate(0 -55)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,337.2h0c-.1,0-.1-.1,0-.1l18.4-24.4h.1c.1,0,.1,0,.1.1l-18.5,24.4Z",
    transform: "translate(0 -55)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,339.1h0c-.1,0-.1-.1,0-.1l18.6-25.5h.1l-18.6,25.5Z",
    transform: "translate(0 -55)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,341h0c-.1-.1-.1-.1,0-.1l18.8-26.5h.1L217.4,341Z",
    transform: "translate(0 -55)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,342.9h0c-.1-.1-.1-.1,0-.2l18.9-27.5h.1c.1,0,.1.1,0,.1l-18.9,27.5Z",
    transform: "translate(0 -55)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,344.8h0c-.1,0-.1,0,0-.1l19.1-28.5c0-.1,0-.1.1-.1h0l-19.1,28.6A.1.1,0,0,1,217.3,344.8Z",
    transform: "translate(0 -55)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M218.8,344.4h0c-.1,0-.1,0-.1-.1l17.8-27.3h.1c.1,0,.1,0,.1.1l-17.8,27.3Z",
    transform: "translate(0 -55)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M220,344.4h-.1l16.8-26.5h.1L220,344.3Z",
    transform: "translate(0 -55)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M221,344.4h0c-.1,0-.1-.1,0-.1l15.9-25.7c0-.1,0-.1.1,0h0l-15.9,25.7Z",
    transform: "translate(0 -55)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M222.5,343.9h0c-.1,0-.1,0,0-.1l19.4-32.9h.1c.1,0,.1,0,.1.1l-19.5,32.9Z",
    transform: "translate(0 -55)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M223.7,343.9h0c-.1,0-.1,0,0-.1l17.7-31.2c0-.1,0-.1.1-.1v.2l-17.7,31.2Z",
    transform: "translate(0 -55)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M224.9,343.9h0s-.1,0,0-.1L241.1,314s0-.1.1,0h0L225,343.9Z",
    transform: "translate(0 -55)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M226.1,343.9h0s-.1,0,0-.1l14.7-28.4h.1l-14.7,28.4Z",
    transform: "translate(0 -55)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M227.3,343.9h0s-.1,0,0-.1l13.1-27h.2l-13.2,27Z",
    transform: "translate(0 -55)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M228.5,343.9h0s-.1,0,0-.1l11.6-25.6h.1c.1,0,.1,0,.1.1l-11.7,25.6Z",
    transform: "translate(0 -55)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.3,343.8h0l-35.6-33.4c-.1,0-.1-.1,0-.1s0-.1.1,0l35.6,33.4h-.1Z",
    transform: "translate(0 -55)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M277,343.8h0l-33.3-32.7c-.1,0-.1,0,0-.1h.1l33.3,32.7H277Z",
    transform: "translate(0 -55)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M274.7,343.8h0l-31.2-31.9c-.1,0-.1-.1,0-.1h.1l31.2,31.9h-.1Z",
    transform: "translate(0 -55)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M272.4,343.8h-.1l-29-31.1c-.1-.1-.1-.1,0-.1s.1-.1.1,0l29.1,31.1h-.1Z",
    transform: "translate(0 -55)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M270.1,343.8H270l-26.9-30.4h.1l27,30.4a.1.1,0,0,1-.1.1Z",
    transform: "translate(0 -55)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M267.8,343.8h-.1l-24.8-29.6h.1l24.8,29.6c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M265.5,343.8h-.1L242.7,315v-.2h.1l22.7,28.8c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M263.2,343.8h-.1l-20.6-28.1h.1l20.6,28.1c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M260.9,343.8h-.1l-18.5-27.3h.1l18.5,27.3c.1.1,0,.1,0,.1Z",
    transform: "translate(0 -55)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M258.6,343.8h-.1l-16.4-26.6h.2l16.3,26.5Z",
    transform: "translate(0 -55)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M256.2,343.8h0L241.9,318a.1.1,0,0,1,.1-.1h.1l14.2,25.8h-.1Z",
    transform: "translate(0 -55)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,329.7h0c-.1-.1-.1-.1,0-.1l17.8-20.3h.1l-17.8,20.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,331.6h0c-.1-.1-.1-.1,0-.2l18-21.2h.1v.2l-18,21.2A.1.1,0,0,1,217.3,331.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,333.5h0c-.1,0-.1,0,0-.1L235.4,311h.1c.1,0,.1.1,0,.1l-18.1,22.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,335.3h0c-.1,0-.1-.1,0-.1l18.3-23.4h.1l-18.3,23.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,337.2h0c-.1,0-.1-.1,0-.1l18.4-24.4h.1c.1,0,.1,0,.1.1l-18.5,24.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,339.1h0c-.1,0-.1-.1,0-.1l18.6-25.5h.1l-18.6,25.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,341h0c-.1-.1-.1-.1,0-.1l18.8-26.5h.1L217.4,341Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,342.9h0c-.1-.1-.1-.1,0-.2l18.9-27.5h.1c.1,0,.1.1,0,.1l-18.9,27.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M217.3,344.8h0c-.1,0-.1,0,0-.1l19.1-28.5c0-.1,0-.1.1-.1h0l-19.1,28.6A.1.1,0,0,1,217.3,344.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M218.8,344.4h0c-.1,0-.1,0-.1-.1l17.8-27.3h.1c.1,0,.1,0,.1.1l-17.8,27.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M220,344.4h-.1l16.8-26.5h.1L220,344.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M221,344.4h0c-.1,0-.1-.1,0-.1l15.9-25.7c0-.1,0-.1.1,0h0l-15.9,25.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M222.5,343.9h0c-.1,0-.1,0,0-.1l19.4-32.9h.1c.1,0,.1,0,.1.1l-19.5,32.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M223.7,343.9h0c-.1,0-.1,0,0-.1l17.7-31.2c0-.1,0-.1.1-.1v.2l-17.7,31.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M224.9,343.9h0s-.1,0,0-.1L241.1,314s0-.1.1,0h0L225,343.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.1,343.9h0s-.1,0,0-.1l14.7-28.4h.1l-14.7,28.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.3,343.9h0s-.1,0,0-.1l13.1-27h.2l-13.2,27Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M228.5,343.9h0s-.1,0,0-.1l11.6-25.6h.1c.1,0,.1,0,.1.1l-11.7,25.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.3,343.8h0l-35.6-33.4c-.1,0-.1-.1,0-.1s0-.1.1,0l35.6,33.4h-.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277,343.8h0l-33.3-32.7c-.1,0-.1,0,0-.1h.1l33.3,32.7H277Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M274.7,343.8h0l-31.2-31.9c-.1,0-.1-.1,0-.1h.1l31.2,31.9h-.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M272.4,343.8h-.1l-29-31.1c-.1-.1-.1-.1,0-.1s.1-.1.1,0l29.1,31.1h-.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.1,343.8H270l-26.9-30.4h.1l27,30.4a.1.1,0,0,1-.1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M267.8,343.8h-.1l-24.8-29.6h.1l24.8,29.6c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.5,343.8h-.1L242.7,315v-.2h.1l22.7,28.8c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M263.2,343.8h-.1l-20.6-28.1h.1l20.6,28.1c.1,0,.1.1,0,.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M260.9,343.8h-.1l-18.5-27.3h.1l18.5,27.3c.1.1,0,.1,0,.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M258.6,343.8h-.1l-16.4-26.6h.2l16.3,26.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M256.2,343.8h0L241.9,318a.1.1,0,0,1,.1-.1h.1l14.2,25.8h-.1Z",
    transform: "translate(0 -55)"
  }))), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 249.8,
    y: 291.1,
    width: 30.4,
    height: 0.98
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "u",
    x: 249.8,
    y: 291.1,
    width: 30.4,
    height: 0.98
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "u",
    x: 249.8,
    y: 291.1,
    width: 30.4,
    height: 0.45
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 249.8,
    y: 291.5,
    width: 30.4,
    height: 0.21
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M242.3,318.2l2-9.9h-.8l-1.9,1.5-.9,3.3h-2.3l-.9-3.3-1.9-1.5h-.8l2,9.9L226.3,347H233l.2-1.2a28.7,28.7,0,0,1,6.4-.5,28.3,28.3,0,0,1,6.3.5l.3,1.2h6.7Zm-3.4-3.9h1.4l-.7,2.8-.8-2.8Zm-5.3,30.1,5.8-24.1c0-.1,0-.2.1-.2h.1a.2.2,0,0,1,.2.2l5.8,24.1Z",
    transform: "translate(0 -55)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M252.9,347l-10.6-28.8,2-9.9-1.7,1.5-.7,3.3h-3.5l-.9-3.3-1.9-1.5,2.7,9.9L229.7,347H233l.2-1.2a44.6,44.6,0,0,1,8-.5,46,46,0,0,1,8.1.5l.3,1.2Zm-11.3-32.6-.7,3.1a.2.2,0,0,1-.2.2h-.8a.2.2,0,0,1-.2-.2l-.9-3.1h2.8Zm-8,30,5.8-24.1c0-.1,0-.2.1-.2h1.7a.2.2,0,0,1,.2.2l7.4,24.1Z",
    transform: "translate(0 -55)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M248.7,347h-2v-.9a.2.2,0,0,1,.2-.2h.9l.4.2Z",
    transform: "translate(0 -55)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M248.7,347H229.8v-1h18.3a.1.1,0,0,0,.1.1l.2.4h0v.2Z",
    transform: "translate(0 -55)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M248.7,347H229.8v-1h18.3a.1.1,0,0,0,.1.1l.2.4h0v.2Z",
    transform: "translate(0 -55)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M248.4,346.5H229.8V346h18.3a.1.1,0,0,0,.1.1l.2.4Z",
    transform: "translate(0 -55)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "248.5 291.7 229.8 291.7 229.8 291.5 248.4 291.5 248.4 291.5 248.5 291.7"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 216.7,
    y: 288.4,
    width: 63.5,
    height: 0.98
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "u",
    x: 216.7,
    y: 288.4,
    width: 63.5,
    height: 0.98
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "u",
    x: 216.7,
    y: 288.4,
    width: 63.5,
    height: 0.45
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 216.7,
    y: 288.9,
    width: 63.5,
    height: 0.21
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M239.7,344.4h-6.1l5.8-24.1c0-.1,0-.2.1-.2h.2v-3l-.8-2.8h.9v-1.2h-1.3l-.9-3.3-1.9-1.5h-.8l2,9.9L226.3,347H233l.2-1.2a28.7,28.7,0,0,1,6.4-.5h.1Z",
    transform: "translate(0 -55)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M239.7,344.4h-6.1l5.8-24.1c0-.1,0-.2.1-.2h.2v-2.5h0l-.9-3.1h.9v-1.2h-1.3l-.9-3.3-1.9-1.5,2.7,9.9L229.7,347H233l.2-1.2a29.8,29.8,0,0,1,6.5-.5Z",
    transform: "translate(0 -55)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M228.8,346.1v.9h-2l.2-.3v-.2h0l.2-.4c.1,0,.1,0,.1-.1h1.2c.1,0,.2,0,.2.1Z",
    transform: "translate(0 -55)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M228.8,346.1v.9H216.7v-1h12.1Z",
    transform: "translate(0 -55)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M228.8,346.1v.9H216.7v-1h12.1Z",
    transform: "translate(0 -55)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M228.8,346.1v.4H216.7V346h12.1Z",
    transform: "translate(0 -55)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 216.7,
    y: 291.5,
    width: 12.1,
    height: 0.21
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.4,309.4v9.1h-1v-8.3h-2.1v-.8Z",
    transform: "translate(0 -55)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M274.2,313.9c0,3.1-1.7,4.7-4.2,4.7a4,4,0,0,1-2.2-.5l.4-.7a3.4,3.4,0,0,0,1.8.4c1.9,0,3.2-1.3,3.2-3.7v-.8a3.1,3.1,0,0,1-2.8,1.6,2.8,2.8,0,1,1,0-5.6C272.8,309.3,274.2,311,274.2,313.9Zm-1.3-1.8a2.2,2.2,0,0,0-2.4-2,2,2,0,1,0,0,4A2.2,2.2,0,0,0,272.9,312.1Z",
    transform: "translate(0 -55)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.5,329.1a11.2,11.2,0,1,1-13.9-7.6A11.1,11.1,0,0,1,272.5,329.1Z",
    transform: "translate(0 -55)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M268.3,338.4a8.9,8.9,0,1,1-.3-12.6A9,9,0,0,1,268.3,338.4Z",
    transform: "translate(0 -55)"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M243.7,202.9v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8h-.3v-.6h.3a1.8,1.8,0,1,0,0-3.6h-.3v-.7h.3a1.8,1.8,0,1,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,1,0,0-3.6h-.3v-.6h.3a1.7,1.7,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.3v-.6h.3a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.3V180h.3a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.3v-.6h.3a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.8-1.8,1.7,1.7,0,0,0-1.8-1.7h-.3v-.6h.3a1.8,1.8,0,1,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,1,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.7v.2a1.8,1.8,0,1,0,3.6,0v-.2h.6v.2a1.8,1.8,0,1,0,3.6,0v-.2h.6v.2a1.7,1.7,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,0,0,3.6,0v-.2h.6v.2a1.8,1.8,0,1,0,3.6,0v-.2h.7v.2a1.8,1.8,0,1,0,3.6,0v-.2h.6v.2a1.8,1.8,0,1,0,3.6,0v-.2h.6v.2a1.7,1.7,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8v-.2h.5v.2a1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.7,1.7,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0,0,3.6h.2v.7h-.2a1.8,1.8,0,1,0,0,3.6h.2v.7h-.2a1.8,1.8,0,0,0,0,3.6h.2v.6h-.2a1.8,1.8,0,0,0,0,3.6h.2v.6h-.2a1.7,1.7,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.5h-.2a1.8,1.8,0,0,0-1.8,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.7,1.7,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-3.6,0v.2h-.6v-.2a1.8,1.8,0,0,0-3.6,0v.2h-.7v-.2a1.8,1.8,0,1,0-3.6,0v.2h-.7v-.2a1.8,1.8,0,0,0-3.6,0v.2H276v-.2a1.8,1.8,0,0,0-3.6,0v.2h-.6v-.2a1.7,1.7,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,0,0-1.8-1.8,1.7,1.7,0,0,0-1.7,1.8v.2h-.6v-.2a1.8,1.8,0,1,0-3.6,0Z",
    transform: "translate(0 -55)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 255,
    y: 146.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(454.6 -153.1) rotate(90)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 255,
    y: 146.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(454.6 -153.1) rotate(90)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "308.1 139.5 273.7 139.5 290.9 117.6 308.1 139.5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "308.1 139.5 273.7 139.5 290.9 117.6 308.1 139.5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "301.2 138.1 307 138.1 303.8 134.1 293.3 133.7 303.5 133.7 300.5 129.8 297.8 129.5 300.2 129.5 298.3 127 289.5 126.7 298 126.7 296.8 125.1 295.6 124.8 296.5 124.8 294.7 122.5 291.7 122.3 294.5 122.3 290.9 117.6 289.8 121.2 292.4 121.2 289.6 121.6 288.6 124.8 294.3 124.8 288.5 125.2 287.6 128 290.7 128 287.5 128.4 286.6 131.2 300.6 131.2 286.5 131.6 284.9 136.6 303.4 136.6 284.8 137.1 284 139.5 308.1 139.5 307.2 138.3 301.2 138.1"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "297.3 139.5 253.5 139.5 270.3 118.1 275.4 111.6 280.2 117.8 297.3 139.5"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "279.6 117.9 280 118 279.3 118 278.6 118.2 279.1 118.3 278 118.6 276.7 118.4 277.7 118.2 276.1 118.2 274.5 118 275 117.8 273.4 117.8 272.5 117.6 273 117.6 272.3 117.5 271.7 117.6 272 117.6 270.3 118.1 275.4 111.6 280.2 117.8 279.6 117.9"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "277.7 114.5 275.4 111.6 274.5 114.5 277.7 114.5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "294.4 135.8 282.7 135.3 294 135.3 289.5 129.6 274.1 129.2 289.2 129.2 287 126.4 281.5 126.1 286.7 126.1 284.4 123.1 277.9 123 284.3 123 281.3 119.2 276.9 118.9 281.1 118.9 277.8 114.7 274.3 114.9 273.6 117.2 277.1 117.2 273.5 117.6 272.4 121.2 279.6 121.2 272.3 121.5 271.5 124.1 283.8 124.1 271.3 124.6 270.3 127.9 275.9 127.9 270.1 128.4 268.9 132.3 283.8 132.3 268.8 132.6 267.1 138.1 292.6 138.1 266.9 138.7 266.6 139.5 297.3 139.5 294.4 135.8"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "279 139.5 244.6 139.5 261.8 117.6 279 139.5"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "279 139.5 244.6 139.5 261.8 117.6 279 139.5"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "272.1 138.1 277.8 138.1 274.7 134.1 264.2 133.7 274.4 133.7 271.3 129.8 268.7 129.5 271.1 129.5 269.1 127 260.4 126.7 268.9 126.7 267.6 125.1 266.5 124.8 267.4 124.8 265.6 122.5 262.5 122.3 265.4 122.3 261.8 117.6 260.6 121.2 263.3 121.2 260.5 121.6 259.5 124.8 265.2 124.8 259.4 125.2 258.5 128 261.6 128 258.4 128.4 257.5 131.2 271.5 131.2 257.3 131.6 255.8 136.6 274.2 136.6 255.6 137.1 254.9 139.5 279 139.5 278 138.3 272.1 138.1"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 244.6,
    y: 139.5,
    width: 63.5,
    height: 5.17
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M297.7,166.3c0,1.5-1.1,2.7-3.3,2.7a4.9,4.9,0,0,1-3.3-1.2l.5-.7a4,4,0,0,0,2.8,1c1.5,0,2.4-.7,2.4-1.8s-.8-1.8-2.5-1.8h-.7v-.7l2.6-3.2h-4.7v-.8h5.9v.6l-2.6,3.3C296.7,163.8,297.7,164.8,297.7,166.3Z",
    transform: "translate(0 -55)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M305.2,168.1v.8h-6.4v-.7l3.8-3.7a3,3,0,0,0,1.2-2.3c0-1-.7-1.7-2.1-1.7a3.1,3.1,0,0,0-2.5,1.1l-.7-.6a4,4,0,0,1,3.3-1.3c1.8,0,3,.9,3,2.4a3.9,3.9,0,0,1-1.5,2.9l-3.1,3.1Z",
    transform: "translate(0 -55)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.1,171.9a11.2,11.2,0,1,1-21.5,6.3,11.2,11.2,0,0,1,21.5-6.3Z",
    transform: "translate(0 -55)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M266.8,181.2a8.9,8.9,0,1,1-.3-12.6A8.8,8.8,0,0,1,266.8,181.2Z",
    transform: "translate(0 -55)"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M180.2,145.6h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.8,1.7,1.8,1.8,0,0,0,1.7-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.8,1.7,1.8,1.8,0,0,0,1.7-1.7v-.3h.6v.3a1.8,1.8,0,0,0,3.6,0v-.3h.6v.3a1.8,1.8,0,0,0,3.6,0v-.3h.7a.4.4,0,0,0-.1.3,1.8,1.8,0,0,0,3.6,0,.4.4,0,0,0-.1-.3h.7a.4.4,0,0,0-.1.3,1.8,1.8,0,0,0,3.6,0v-.3h.6v.3a1.8,1.8,0,0,0,3.6,0v-.3h.6v.3a1.7,1.7,0,0,0,1.7,1.7,1.8,1.8,0,0,0,1.8-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.7,1.7,1.8,1.8,0,0,0,1.8-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.7,1.7,1.8,1.8,0,0,0,1.8-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.8,1.7,1.8,1.8,0,0,0,1.7-1.7v-.3h.6v.3a1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.7,1.7,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.7h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.7,1.8,1.8,0,0,0,1.7,1.8h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.8,1.8,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0-1.7,1.8,1.7,1.7,0,0,0,1.7,1.7h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.7h-.3a1.8,1.8,0,0,0,0,3.6h.3v.6h-.3a1.8,1.8,0,0,0,0,3.6h.3v.5h-.3a1.8,1.8,0,0,0-1.7,1.7v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.7,1.8,1.8,0,0,0-1.7,1.7v.3H223v-.3a1.8,1.8,0,0,0-3.6,0v.3h-.6v-.3a1.8,1.8,0,0,0-3.6,0v.3h-.7a.4.4,0,0,0,.1-.3,1.8,1.8,0,0,0-3.6,0,.4.4,0,0,0,.1.3h-.7a.4.4,0,0,0,.1-.3,1.8,1.8,0,0,0-3.6,0v.3h-.6v-.3a1.8,1.8,0,0,0-3.6,0v.3h-.6v-.3a1.7,1.7,0,0,0-1.7-1.7,1.8,1.8,0,0,0-1.8,1.7v.3h-.6v-.3a1.8,1.8,0,0,0-1.7-1.7,1.8,1.8,0,0,0-1.8,1.7v.3h-.6v-.3a1.8,1.8,0,0,0-1.7-1.7,1.8,1.8,0,0,0-1.8,1.7v.3h-.6v-.3a1.8,1.8,0,0,0-1.8-1.7,1.8,1.8,0,0,0-1.7,1.7v.3H186v-.3a1.8,1.8,0,0,0-1.8-1.7,1.8,1.8,0,0,0-1.7,1.7v.3h-.6v-.3a1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.7,1.7,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,0,0,0-3.6h-.3v-.7h.3a1.8,1.8,0,0,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,0,0,0-3.6h-.3V182h.3a1.7,1.7,0,0,0,1.7-1.7,1.8,1.8,0,0,0-1.7-1.8h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.7,1.8,1.8,0,0,0-1.7-1.8h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.7,1.8,1.8,0,0,0-1.7-1.8h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.8,1.8,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,1.7-1.8,1.7,1.7,0,0,0-1.7-1.7h-.3v-.6h.3a1.8,1.8,0,0,0,0-3.6h-.3v-.6h.3a1.8,1.8,0,0,0,0-3.6Z",
    transform: "translate(0 -55)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 183.4,
    y: 146.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(409.6 301.6) rotate(180)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: 183.4,
    y: 146.5,
    width: 42.8,
    height: 63.48,
    transform: "translate(409.6 301.6) rotate(180)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M223.2,208.7a73.2,73.2,0,0,1-8.3-12.2v-1.8H214l-.5-.8h.6a.2.2,0,0,0,.2-.2l-.2-.2h-.8c-.6-1.1-1.1-2.3-1.7-3.5a35.8,35.8,0,0,1-2.5-7.2h.1a.2.2,0,0,0,.2-.2v-.2c0-.2-.1-.2-.2-.2h-.3c-2.7-11.1-2.7-24.4-2.7-24.5v-.2h.1l.2-.2v-.5c0-.1-.1-.1-.2-.1H206v-.4h0v-.4a.2.2,0,0,0-.2-.2h-.5v-.2h-.1v-2.9a.3.3,0,0,0-.3-.3.3.3,0,0,0-.3.3v2.9h-.1v.2h-.5a.2.2,0,0,0-.2.2v.4h.1v.4h-.4c-.1,0-.2,0-.2.1v.5a.2.2,0,0,0,.2.2h.2c-.1,0-.1.1-.1.2s0,13.4-2.7,24.5h-.3c-.1,0-.2,0-.2.2v.2l.2.2h.1A35.8,35.8,0,0,1,198,190c-.6,1.2-1.1,2.4-1.7,3.5h-.8l-.2.2a.2.2,0,0,0,.2.2h.6l-.5.8h-.9v1.8a73.2,73.2,0,0,1-8.3,12.2s-.1.2,0,.3h6.5c0-.1,2.3-3.3,4.7-7.5a11.3,11.3,0,0,1,14.4,0c2.4,4.2,4.7,7.4,4.7,7.5h6.5C223.3,208.9,223.2,208.7,223.2,208.7Zm-21.7-15.2a19.2,19.2,0,0,0,1.1-3.7c.4-1.3.6-2.8.9-4.3h2.6c.3,1.5.5,3,.9,4.3a30.4,30.4,0,0,0,1.1,3.7Z",
    transform: "translate(0 -55)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M223.2,208.7a73.2,73.2,0,0,1-8.3-12.2v-1.8H214l-.5-.8h.6a.2.2,0,0,0,.2-.2l-.2-.2h-.8c-.6-1.1-1.1-2.3-1.7-3.5a35.8,35.8,0,0,1-2.5-7.2h.1a.2.2,0,0,0,.2-.2v-.2c0-.2-.1-.2-.2-.2h-.3c-2.7-11.1-2.7-24.4-2.7-24.5v-.2h.1l.2-.2v-.5c0-.1-.1-.1-.2-.1H206v-.4h0v-.4a.2.2,0,0,0-.2-.2h-.5v-.2h-.1v-2.9a.3.3,0,0,0-.3-.3.3.3,0,0,0-.3.3v2.9h-.1v.2h-.5a.2.2,0,0,0-.2.2v.4h.1v.4h-.4c-.1,0-.2,0-.2.1v.5a.2.2,0,0,0,.2.2h.2c-.1,0-.1.1-.1.2s0,13.4-2.7,24.5h-.3c-.1,0-.2,0-.2.2v.2l.2.2h.1A35.8,35.8,0,0,1,198,190c-.6,1.2-1.1,2.4-1.7,3.5h-.8l-.2.2a.2.2,0,0,0,.2.2h.6l-.5.8h-.9v1.8a73.2,73.2,0,0,1-8.3,12.2s-.1.2,0,.3h6.5c0-.1,2.3-3.3,4.7-7.5a11.3,11.3,0,0,1,14.4,0c2.4,4.2,4.7,7.4,4.7,7.5h6.5C223.3,208.9,223.2,208.7,223.2,208.7Zm-21.7-15.2a19.2,19.2,0,0,0,1.1-3.7c.4-1.3.6-2.8.9-4.3h2.6c.3,1.5.5,3,.9,4.3a30.4,30.4,0,0,0,1.1,3.7Z",
    transform: "translate(0 -55)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.6,179l-.8-.7c.1.5.1.9.2,1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "205.8 122.8 206.5 122.8 206.4 122.1 205.8 122.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.3,176h-.6l.7.5V176Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.8,173.8l-.4-.3v.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.3,172.3v.4l.3-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "205.5 128.4 204.1 128.4 204.8 129 205.5 128.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,183.6l-.8.5.9.7C206,184.4,205.9,184,205.9,183.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "204.8 129.4 203.8 130.2 205.8 130.2 204.8 129.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,167.7l-.3-.4v.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.7,175.7h.6c0-.2-.1-.4-.1-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.4,172h.5v-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.4,170.5h0l.5.5a1.3,1.3,0,0,1-.1-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.3,176.8l-.6-.5a4.5,4.5,0,0,0,.1,1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.4,170.8v1l.4-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,174.1l.6.5a.9.9,0,0,1-.1-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,173.8h.5a1.1,1.1,0,0,0-.1-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.5,172.3l.5.5v-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.5,172.7v.8l.4-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203,179l.6.7c.1-.5.1-.9.2-1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,181.8a4.9,4.9,0,0,0-.1-1.2l-.5.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,174.4v1l.5-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.3,168.1v-.8l-.3.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.5,184.1l-.8-.5c0,.4-.1.8-.1,1.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.1,180.3l.9.6a1.3,1.3,0,0,1-.1-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206,180h.8v-.3a4.3,4.3,0,0,1-.1-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "206.8 122.3 206.8 122.8 207.4 122.8 206.8 122.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.8,182.8h-2v.2h2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204,175.4v-1l-.5.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "205.6 127.2 204.8 126.4 204 127.2 205.6 127.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.3,176.8l.5.6a4.5,4.5,0,0,0,.1-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.1,173.5v-.8l-.4.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204,181.8l.6-.7-.5-.5C204.1,181,204,181.4,204,181.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "204.2 125.3 204.8 126 205.4 125.3 204.2 125.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.8,179.1l-.6.9h1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,171.3l.4.5v-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.1,188.1a1.4,1.4,0,0,0-.2.7l1.3-.9h-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.6,187.3l.3-1.6-1.2.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.1,189.7c.1-.5.3-1,.4-1.5l-1.6,1,1.1,1.1C202,190.1,202.1,189.9,202.1,189.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.3,190.5h1.4l-1.1-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.8,187.6c.1-.2.1-.5.2-.7l-1.1.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "201.9 130.2 202.7 130.2 202 129.6 201.9 129.8 201.9 130.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203,184.9a5.1,5.1,0,0,0,.2-1.3l-1,.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.2 128.5 202.1 128.9 202.9 128.4 202.2 128.4 202.2 128.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.1 127.2 202.2 126.6 201.4 127.2 202.1 127.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.9,190.9v.2l.3.7.9-.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.9,192.1l-2-1,.7,2.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209,193.5h1.5c-.1-.4-.3-.7-.4-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200,191.3l-.2.4,1.6-.8h-1.3C200.1,191,200,191.2,200,191.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206,180.6c.1.4.1.9.2,1.3l.7-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M199.8,190.5l.4-.9-1.6.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.7,191.1l-2,1,1.3,1.2A18.7,18.7,0,0,0,201.7,191.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.3,189.1l1.8,1.1-.9-2.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.3,175.7h.6l-.5-.6A1.3,1.3,0,0,1,203.3,175.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.2,176.5l.7-.5h-.6v.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.4,174.6l.6-.5h-.5A.9.9,0,0,1,203.4,174.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.3,172.7v-.4H203Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.5,173.8h.5l-.4-.5A4.3,4.3,0,0,1,203.5,173.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,171.1l.4-.5h-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.6,172.8l.5-.5h-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.7,172.1h.5l-.5-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.8,179.7v.3h.8l-.7-.8A.7.7,0,0,1,202.8,179.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.5,180.3h-.8v.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.9,187.9l.3.8.7-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.4 127.2 203.2 127.2 202.6 126.5 202.4 127.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.4,181.9c.1-.4.1-.9.2-1.3l-.9.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.8 122.8 202.8 122.3 202.2 122.8 202.8 122.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "203.1 122.8 203.8 122.8 203.2 122.1 203.1 122.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.3,183h1v-.2h-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.2,173.8v-.3l-.4.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.7,193.9h-1.8a.8.8,0,0,1-.2.5v.3h1.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M196.3,198.3l.5-1,.4-.6h-2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.7,167.6l-.2-.3a2.5,2.5,0,0,0-.1.8l.3-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M197.1,193.5h1.5c.2-.3.3-.7.5-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M197.7,196.7a5.6,5.6,0,0,1-.5.8.8.8,0,0,1-.2.5l2.4-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.6 143.2 203.7 143.2 203.7 141.6 203.7 141.6 202.6 141.6 202.6 141.6 202.6 143.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M213.5,198.5l2.9,1.6-1.8-3.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "205.9 143.2 207 143.2 207 141.6 207 141.6 205.9 141.6 205.9 141.6 205.9 143.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.3,193.9h-7l-.3.8h7.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.3,170v-1l-.4.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.6,175.7h.4a.6.6,0,0,1,.1-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.4,166.4v-.8l-.3.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.4,177.7h.9l-.5-.7-.4.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.2,194.7H211v-.3a.8.8,0,0,1-.2-.5h-1.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,167.8l.3.3a2.5,2.5,0,0,0-.1-.8l-.2.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M212.5,193.5l-2-1,.5,1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.1,178h0a1.3,1.3,0,0,0-.1.6l.7-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.6,178.9l-.3-.5c0,.3-.1.7-.1,1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205,173.9v-.3l-.2-.4-.2.4v.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,208.6h2.2l-1.2-1.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M222,208.6l-3-1.4,1.2,1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.8,170.3h0v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.8,170.5a8.6,8.6,0,0,0-.1,1.6h.2a8.6,8.6,0,0,0-.1-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.9,172.9h.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.9,172.5v-.2h-.2v.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.3,204.8l.3.5.5.7.3.3,1-1.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M215.9,202.6l3.1,1.5-2-3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M219,204.5l-2.9-1.5v.2l.9,1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M217.2,205.6l-.5-.7H215l2.6,1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M215.7,202.3l1-1.4h-2A7.1,7.1,0,0,0,215.7,202.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M214.3,204.2l1-1.4c0-.1,0-.2-.1-.2l-2.8-1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M213.7,199l.8,1.5h1.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M215.8,203.4l-.3-.3-1,1.4h1.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M214.9,202l-.7-1.1h-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.4,176.4v.7l.2-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.8,191.7c-.1-.1-.1-.3-.2-.4s-.1-.3-.1-.4h-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M211,190.5l-1.6-.9a3.6,3.6,0,0,1,.4.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207,175.7l-.5-.4a.6.6,0,0,1,.1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.9,190.5h1.4l-.3-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.5,187.9h-1.1l1.3.9a1.4,1.4,0,0,0-.2-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205,178.9l.4.6c0-.4-.1-.8-.1-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,178l.7.6a1.3,1.3,0,0,0-.1-.6h-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.3,169a3.8,3.8,0,0,0,.1,1l.3-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "206.4 127.2 207.2 127.2 207 126.5 206.4 127.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "207.4 128.4 206.7 128.4 207.5 128.9 207.4 128.5 207.4 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "207.4 126.6 207.5 127.2 208.2 127.2 207.4 126.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.3,182.8v.2h1v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "204.8 123.7 205.3 123 204.3 123 204.8 123.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.9,186.5l-1.2-.8.3,1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.5,189.7c0,.2.1.4.1.6l1.1-1.1-1.6-1C207.2,188.7,207.4,189.2,207.5,189.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.7,187.6l-1.1-.7c.1.2.1.5.2.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.4,183.6c.1.5.1.9.2,1.3l.8-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "207.7 129.8 207.6 129.6 206.9 130.2 207.8 130.2 207.7 129.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.2,160l.2.3v-.7l-.2.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,165.6v.8l.3-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,159.3l.2.3v-.4h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.4,162.5v-.9l-.2.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.2,161.6l.2-.4V161h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.2,164.1l.2.4v-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.2,159.6l.2-.3h-.1A.6.6,0,0,1,204.2,159.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.3,157.9V159h.1v-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.2,160.8h.2l-.2-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.4,162l-.2-.4v.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205,176.7l.2.4v-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,157.9V159h.2a3.7,3.7,0,0,1-.1-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,163.7v.8l.3-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,161v.2l.2.4V161Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,160.3l.2-.3h0l-.2-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,160.8h.2v-.5l-.2.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.6,173.1h.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.3,168.8l.3.3v-.4h-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.5,188.7a3.1,3.1,0,0,1,.2-.8h-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M199.4,191.8a2.5,2.5,0,0,1,.2-.7v-.2h-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M199.7,187.3l1.4-.9-.8-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.2,186.1c.1-.2.1-.4.2-.6h-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.7,193.5l-1.2-1.1a4.9,4.9,0,0,1-.4,1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.2,187.6h1.2l-1-.9A2.9,2.9,0,0,1,201.2,187.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.8,185.5h-.1a.9.9,0,0,1-.1.5l1-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "201.5 130.2 201.6 129.7 201.6 129.7 200.8 130.2 201.5 130.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M212.4,197.5a2,2,0,0,1-.4-.8h-1.8l2.4,1.3C212.5,197.9,212.5,197.7,212.4,197.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.5,196.5h-.2v.2h-.1a10.1,10.1,0,0,0-.7,1.5h1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M213.3,198.3l1.1-1.6h-1.9l.3.6A4.7,4.7,0,0,0,213.3,198.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M210.5,198.7h-2.8a13.1,13.1,0,0,1,3.7,1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M209.4,196.7v-.2h-.2v1.7h1.1a10.1,10.1,0,0,0-.7-1.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "208.6 141.6 208.6 141.6 207.5 141.6 207.5 141.6 207.5 143.2 208.6 143.2 208.6 141.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M198.2,200.3a13.1,13.1,0,0,1,3.7-1.6h-2.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "202.1 141.6 202.1 141.6 201 141.6 201 141.6 201 143.2 202.1 143.2 202.1 141.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201,183h.9v-.2h-.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203,171.8l.4-.4v-.2h.1l-.4-.4A3.4,3.4,0,0,1,203,171.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.8,173.5l.5-.4h0l-.4-.4A2.8,2.8,0,0,1,202.8,173.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203,172.1h.4v-.5l-.4.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "201.8 128.9 201.8 128.5 201.8 128.4 201.2 128.4 201.7 128.9 201.8 128.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.6,175.4l.5-.5h0l-.4-.4A3.1,3.1,0,0,0,202.6,175.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.2,170l.4-.4v-.2l-.3-.4A3.8,3.8,0,0,1,203.2,170Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.2,170.6l.3.3v-.4h-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.2,170.3h.3v-.4l-.3.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.1,174.5a.8.8,0,0,0,.1-.4h-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.3,181.9l1-.7h0l-.7-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.3,180.8a4.3,4.3,0,0,0,.1-.5h-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.4,180a.4.4,0,0,0,.1-.3v-.3l-.7.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M211.1,193.9l.2.4.2.4h1.9l-.5-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.8,179.7l.8-.7h0l-.5-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.2,177.4l.7-.6h0l-.5-.6A5,5,0,0,1,202.2,177.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.7,178.5V178h-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.9,176.4h0a.4.4,0,0,0,.1-.3h-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M198.5,190.2l1.8-1.1-.9-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M189.9,205a36.7,36.7,0,0,1-2.4,3.2l3.5-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M210.5,192l2,1.1-1-2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M197.2,201.2l-2.8,1.4c-.1,0-.1.1-.1.2l1.1,1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M190.6,204.1l3.1-1.5-1.1-1.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M194.1,203.1l-.3.3-.6,1.1h1.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M194.9,200.9h-2l1.1,1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M193.4,203.2V203l-2.9,1.5h2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M192.9,204.8h0l-.5.7-.3.5,2.5-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M193.2,200.5h1.9a10.9,10.9,0,0,0,.8-1.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M212.9,198.6l-2.6-1.4,1.6,3.1,1.1-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M191.6,206.7h-.1l1.1,1.7c.3-.5,1.2-1.7,2.2-3.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M218.1,206.8H218l-3.2-1.6c1,1.7,1.9,2.9,2.2,3.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M218.7,206.6l3.4,1.6a36.7,36.7,0,0,1-2.4-3.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M213.2,199.1l-1,1.4H214A10,10,0,0,1,213.2,199.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "205.3 141.6 205.3 141.6 204.3 141.6 204.3 141.6 204.3 143.2 205.3 143.2 205.3 141.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M195.6,200.5h1.8l-1-1.4A10,10,0,0,1,195.6,200.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M199.3,197.2l-2.6,1.4h-.1l1.1,1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M194.7,202l2.3-1.1h-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.6,174.6c0,.2-.1.3-.1.4l.2-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205,174.6v.4A.8.8,0,0,0,205,174.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M192.3,204.8h-2.1l1,1.5.3-.3.5-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.5,175.7h.6l-.3-.5-.3.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204,161.5V161h-.2v.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,161v.5l.2-.3V161Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208,184.2l1.1.6c-.1-.4-.3-.8-.4-1.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.7,164v.2l.2.3v-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.6,174h0l.2.4.2-.4h-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.9,164.2V164l-.2-.3v.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M196.1,198.5,195,197c-.6,1.1-1.2,2.2-1.8,3.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M189.4,208.6l1.2-1.4-3,1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M191.3,207.1l-1.2,1.5h2.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M201.6,184.2l-.7-.6c-.1.4-.3.8-.4,1.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M198.1,194.7c.1-.1.1-.3.2-.4s.1-.3.2-.4h-1.8a3,3,0,0,0-.4.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M199.1,192l-1-.9c-.3.7-.7,1.3-1,2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206,169.4v.2l.4.4a3.8,3.8,0,0,1-.1-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.5,186.4l1.4.9-.6-1.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206,168.7v.4l.3-.3H206Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,168.1v.4h.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,167v.3l.2-.2h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.4,168.5h.2a.6.6,0,0,0,.1-.4l-.3.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.8,166.4c0,.1.1.3.1.4h.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.1,169.9v.4h.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.2,171.6v.5h.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.1,170.5v.4l.3-.3h-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.7,162.5v.6h.2v-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.9,163.3h-.2v.4l.2-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,161.9v.2l.2.3v-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.3,168.7h0l.4.4v-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.8,165.2v.4l.2-.3h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.8,165.8v.2l.3.4a2.5,2.5,0,0,1-.1-.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.4,170.3h.4v-.6l-.4.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.7,164.5c0,.2.1.3.1.5h.2v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.2,185.5c.1.2.1.4.2.6l.6-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.5,182.8h-.9v.2h.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.8,185.5H207l1,.6a.9.9,0,0,1-.1-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "207.8 128.4 207.8 128.5 207.9 128.9 207.9 128.9 208.4 128.4 207.8 128.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.4,181.2h0l.9.7-.3-1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.3,168.5h.4v-.6l-.4.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.4,187.6a2.9,2.9,0,0,1-.2-.9l-1,.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.3,180.8l.6-.5h-.7A4.3,4.3,0,0,0,207.3,180.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "208 129.7 208.1 130.2 208.9 130.2 208 129.7 208 129.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.5,174.8h0l.6.5c-.1-.4-.1-.7-.2-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.3,173h0l.5.4c0-.3-.1-.6-.1-.9Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.7,176.3h0l.4-.4h-.5A.4.4,0,0,0,206.7,176.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207.1,179.7c0,.1.1.2.1.3h.6l-.7-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.5,174.5l.3-.4h-.4A.8.8,0,0,0,206.5,174.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.7,176.8h0l.7.6c-.1-.4-.1-.8-.2-1.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M207,178.9h0l.8.7-.3-1.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.9,178a.7.7,0,0,0,.1.5l.4-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.2,171.2h0v.2l.4.4a3.4,3.4,0,0,1-.1-1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.3,167.1H204v.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,160.8h.2v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,163.1h.1v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,162.4l.2-.3v-.2l-.2-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.9,168.5h.4l-.3-.5A1.3,1.3,0,0,0,203.9,168.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204,166.8h.4l-.4-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.9,159.4v-.2h-.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.9,160.3v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.9,159h.1a4.5,4.5,0,0,1,.1-1.1h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.5,166.8h.2a.6.6,0,0,0,.1-.4l-.3.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.6,165.3l.2.3v-.4h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.5,166.4l.3-.4v-.2l-.2-.2A2.5,2.5,0,0,1,203.5,166.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.5,167.1l.2.2V167h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.8,170.3h.4l-.4-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.6,165h.2a.9.9,0,0,0,.1-.5l-.2.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.3,168.8h-.4v.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.7,163.4l.2.3v-.4h-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,164.8v.2h.3v-.6Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,157.9V159h.1v-1.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,163.3h0l.3.4a.7.7,0,0,0-.1-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,165.2h0l.3.4v-.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.3,167h0l.3.4V167Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.3,166.8h.3v-.6l-.3.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,159.2v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.8,160.6l-.2-.2v.4h.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.6,160v0Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 204.2,
    y: 101.5,
    width: 0.4,
    height: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.4,163.1v-.2l-.2-.5v.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.2,162.9v.2h.2v-.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.1,165h.3v-.2l-.3-.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.1,163.8l.3-.4h-.2A1.1,1.1,0,0,1,204.1,163.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 205.1,
    y: 101.5,
    width: 0.4,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "204.5 121 204.8 121.5 205.1 121 205.1 121 204.5 121 204.5 121"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M204.1,165.7l.3-.4h-.3Z",
    transform: "translate(0 -55)"
  }))), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 183.4,
    y: 154.2,
    width: 42.8,
    height: 0.88
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.7,150.3v9.1h-.9v-8.3h-2.2v-.8Z",
    transform: "translate(0 -55)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M197.1,156.7c0,1.6-1.1,2.8-3.3,2.8a4.9,4.9,0,0,1-3.3-1.2l.5-.7a3.8,3.8,0,0,0,2.8,1c1.5,0,2.3-.7,2.3-1.9s-.7-1.9-3-1.9h-2l.5-4.5h5v.8h-4.2l-.3,2.9h1.2C196,154,197.1,155.1,197.1,156.7Z",
    transform: "translate(0 -55)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M223.7,165.6a11.2,11.2,0,1,1-21.5,6.4,11.2,11.2,0,0,1,21.5-6.4Z",
    transform: "translate(0 -55)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M219.4,175a8.9,8.9,0,0,1-13-12.3,8.9,8.9,0,1,1,13,12.3Z",
    transform: "translate(0 -55)"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M257,218.5h-.2V218h.2a1.8,1.8,0,0,0,1.8-1.8V216h.6v.2a1.8,1.8,0,1,0,3.6,0V216h.7v.2a1.8,1.8,0,0,0,3.6,0V216h.6v.2a1.8,1.8,0,0,0,3.6,0V216h.6v.2a1.7,1.7,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8V216h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8V216h.6v.2a1.8,1.8,0,0,0,1.7,1.8,1.8,1.8,0,0,0,1.8-1.8V216h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8V216h.6v.2a1.8,1.8,0,0,0,1.8,1.8,1.8,1.8,0,0,0,1.7-1.8V216h.6v.2A1.8,1.8,0,0,0,294,218a1.8,1.8,0,0,0,1.7-1.8V216h.6v.2a1.8,1.8,0,1,0,3.6,0V216h.6v.2a1.8,1.8,0,0,0,3.6,0V216h.6v.2a1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0,0,3.6h.2v.6h-.2a1.8,1.8,0,1,0,0,3.6h.2v.6h-.2a1.8,1.8,0,0,0,0,3.6h.2v.7h-.2a1.8,1.8,0,0,0,0,3.6h.2v.6h-.2a1.8,1.8,0,0,0,0,3.6h.2v.6h-.2a1.7,1.7,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.7,1.8,1.8,0,0,0,1.8,1.8h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8,1.8,1.8,0,0,0,1.8,1.7h.2v.6h-.2a1.8,1.8,0,0,0-1.8,1.8v.3h-.6V286a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3h-.6V286a1.8,1.8,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3h-.6V286a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.3h-.6V286a1.8,1.8,0,0,0-1.8-1.8,1.8,1.8,0,0,0-1.7,1.8v.3h-.6V286a1.8,1.8,0,0,0-1.8-1.8A1.8,1.8,0,0,0,284,286v.3h-.6V286a1.8,1.8,0,1,0-3.6,0c0,.1.1.2.1.3h-.6V286a1.8,1.8,0,0,0-3.6,0c0,.1.1.2.1.3h-.7a.4.4,0,0,0,.1-.3,1.8,1.8,0,1,0-3.6,0,.4.4,0,0,0,.1.3H271a.4.4,0,0,0,.1-.3,1.8,1.8,0,0,0-3.6,0v.3h-.6c0-.1.1-.2.1-.3a1.8,1.8,0,0,0-3.6,0v.3h-.6V286a1.7,1.7,0,0,0-1.7-1.8,1.8,1.8,0,0,0-1.8,1.8v.3h-.5V286a1.8,1.8,0,0,0-1.8-1.8h-.2v-.7h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.7,1.7,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2V259h.2a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.8,1.8,1.8,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,0,0,1.8-1.8,1.7,1.7,0,0,0-1.8-1.7h-.2v-.6h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.7h.2a1.8,1.8,0,1,0,0-3.6h-.2v-.6h.2a1.8,1.8,0,0,0,0-3.6h-.2v-.6h.2a1.7,1.7,0,0,0,1.8-1.7,1.8,1.8,0,0,0-1.8-1.8h-.2V222h.2a1.8,1.8,0,0,0,1.8-1.7A1.8,1.8,0,0,0,257,218.5Z",
    transform: "translate(0 -55)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 260.2,
    y: 219.4,
    width: 42.8,
    height: 63.48,
    transform: "translate(563.3 447.3) rotate(180)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 260.2,
    y: 219.4,
    width: 42.8,
    height: 63.48,
    transform: "translate(563.3 447.3) rotate(180)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M281.6,263.5v-3.3h0c.2,0,.4-.2.3-.4h0a.4.4,0,0,0-.4-.4h0c0-1.1-.1-2.2-.2-3.2h0a.5.5,0,0,0,.3-.5h0c0-.2-.2-.4-.4-.3s-.3-2.3-.5-3.3h0c.2,0,.3-.3.3-.5a.5.5,0,0,0-.5-.3h0a29.9,29.9,0,0,0-.8-3.2h.1c.2,0,.3-.3.2-.5h0c0-.2-.3-.3-.5-.3h0a28.1,28.1,0,0,0-1-3.1c.8-.1,1.3-.3,1.3-.4s-1.1-.5-2.6-.5-2.6.2-2.6.5,1.2.4,2.6.4h.2c2.9,7.8,4.9,19.5.9,35.7l1.1.2c.3-1.2.5-2.4.8-3.6h0c.2,0,.4-.1.4-.3h0c.1-.2-.1-.4-.3-.5h0l.6-3.2h0c.2,0,.4-.1.4-.3h0c0-.2-.1-.4-.3-.4h0c.1-1.1.3-2.2.3-3.3h.1c.2,0,.4-.1.4-.3h0a.4.4,0,0,0-.4-.4h0c.1-1.1.2-2.2.2-3.3h0c.2,0,.4-.1.4-.3h0A.4.4,0,0,0,281.6,263.5Z",
    transform: "translate(0 -55)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M281.6,263.5v-3.3h0c.2,0,.4-.2.3-.4h0a.4.4,0,0,0-.4-.4h0c0-1.1-.1-2.2-.2-3.2h0a.5.5,0,0,0,.3-.5h0c0-.2-.2-.4-.4-.3s-.3-2.3-.5-3.3h0c.2,0,.3-.3.3-.5a.5.5,0,0,0-.5-.3h0a29.9,29.9,0,0,0-.8-3.2h.1c.2,0,.3-.3.2-.5h0c0-.2-.3-.3-.5-.3h0a28.1,28.1,0,0,0-1-3.1c.8-.1,1.3-.3,1.3-.4s-1.1-.5-2.6-.5-2.6.2-2.6.5,1.2.4,2.6.4h.2c2.9,7.8,4.9,19.5.9,35.7l1.1.2c.3-1.2.5-2.4.8-3.6h0c.2,0,.4-.1.4-.3h0c.1-.2-.1-.4-.3-.5h0l.6-3.2h0c.2,0,.4-.1.4-.3h0c0-.2-.1-.4-.3-.4h0c.1-1.1.3-2.2.3-3.3h.1c.2,0,.4-.1.4-.3h0a.4.4,0,0,0-.4-.4h0c.1-1.1.2-2.2.2-3.3h0c.2,0,.4-.1.4-.3h0A.4.4,0,0,0,281.6,263.5Z",
    transform: "translate(0 -55)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M265.6,243.8V280h12.2c5.1-20.5.1-33.4-1.1-36.2Z",
    transform: "translate(0 -55)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.4,249h-13v-1.3h12.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279,251.6H265.4v-1.3h13.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.5,254.2H265.4v-1.3h13.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.8,256.7H265.4v-1.3h14.2C279.7,255.9,279.7,256.3,279.8,256.7Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,259.3H265.4V258h14.5A5.7,5.7,0,0,0,280,259.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,261.9H265.4v-1.3H280Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,263.2v1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,265.7a6.2,6.2,0,0,0-.1,1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.8,268.3a5.7,5.7,0,0,0-.1,1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.5,270.9a6.9,6.9,0,0,1-.2,1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.1,273.5a6.9,6.9,0,0,1-.2,1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.7,276l-.3,1.3h-13V276Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.1,278.6l-.3,1.3H265.4v-1.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.7,246.4H265.4v-1.3h11.8A11.2,11.2,0,0,0,277.7,246.4Z",
    transform: "translate(0 -55)"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M276.7,244H265.6v-.2h11.1Z",
    transform: "translate(0 -55)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M277.2,245.2H265.6V245h11.5Z",
    transform: "translate(0 -55)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M277.7,246.5H265.6v-.2h12Z",
    transform: "translate(0 -55)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.1,247.8H265.6v-.2H278A.3.3,0,0,1,278.1,247.8Z",
    transform: "translate(0 -55)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.4,249.1H265.6v-.2h12.8Z",
    transform: "translate(0 -55)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.8,250.4H265.6v-.3h13.1A.4.4,0,0,0,278.8,250.4Z",
    transform: "translate(0 -55)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279,251.7H265.6v-.3H279Z",
    transform: "translate(0 -55)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.3,253H265.6v-.3h13.6C279.2,252.8,279.3,252.9,279.3,253Z",
    transform: "translate(0 -55)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.5,254.3H265.6V254h13.8C279.4,254.1,279.5,254.2,279.5,254.3Z",
    transform: "translate(0 -55)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.6,255.6h-14v-.3h14Z",
    transform: "translate(0 -55)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.8,256.8H265.6v-.2h14.2Z",
    transform: "translate(0 -55)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.9,258.1H265.6v-.2h14.3Z",
    transform: "translate(0 -55)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,259.4H265.6v-.2H280Z",
    transform: "translate(0 -55)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,260.7H265.6v-.3H280Z",
    transform: "translate(0 -55)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,262H265.6v-.3H280Z",
    transform: "translate(0 -55)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,263v.3H265.6V263Z",
    transform: "translate(0 -55)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,264.3v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M280,265.6v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.9,266.9v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.8,268.2v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.7,269.5a.3.3,0,0,1-.1.2h-14v-.2Z",
    transform: "translate(0 -55)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.5,270.7v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.4,272a.4.4,0,0,0-.1.3H265.6V272Z",
    transform: "translate(0 -55)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M279.2,273.3a.4.4,0,0,0-.1.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.9,274.6v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.7,275.9v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.4,277.2v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M278.2,278.5v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M277.9,279.8c-.1,0-.1.1-.1.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M276.7,244H265.6v-.2h11.1Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.2,245.2H265.6V245h11.5Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.7,246.5H265.6v-.2h12Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.1,247.8H265.6v-.2H278A.3.3,0,0,1,278.1,247.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.4,249.1H265.6v-.2h12.8Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.8,250.4H265.6v-.3h13.1A.4.4,0,0,0,278.8,250.4Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279,251.7H265.6v-.3H279Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.3,253H265.6v-.3h13.6C279.2,252.8,279.3,252.9,279.3,253Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.5,254.3H265.6V254h13.8C279.4,254.1,279.5,254.2,279.5,254.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.6,255.6h-14v-.3h14Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.8,256.8H265.6v-.2h14.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.9,258.1H265.6v-.2h14.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,259.4H265.6v-.2H280Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,260.7H265.6v-.3H280Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,262H265.6v-.3H280Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,263v.3H265.6V263Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,264.3v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280,265.6v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.9,266.9v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.8,268.2v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.7,269.5a.3.3,0,0,1-.1.2h-14v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.5,270.7v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.4,272a.4.4,0,0,0-.1.3H265.6V272Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.2,273.3a.4.4,0,0,0-.1.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.9,274.6v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.7,275.9v.3H265.6v-.3Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.4,277.2v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.2,278.5v.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.9,279.8c-.1,0-.1.1-.1.2H265.6v-.2Z",
    transform: "translate(0 -55)"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M275.9,240.6a39,39,0,0,0-8-11.3v-.5h0v-8.3h-.5v8.3h-1V280h1.5v-9.6H279a76.7,76.7,0,0,1-1.7,9.5l1,.2C282.9,261.3,279.6,248.2,275.9,240.6Zm-8-9.8a36.8,36.8,0,0,1,7.1,10.3,43.7,43.7,0,0,1,2.2,5.6h-9.3Zm9.5,16.5a59.2,59.2,0,0,1,2,10.9H267.9V247.3Zm1.7,22.4H267.9V258.9h11.5A57.4,57.4,0,0,1,279.1,269.7Z",
    transform: "translate(0 -55)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M275.9,240.6a39,39,0,0,0-8-11.3v-.5h0v-8.3h-.5v8.3h-1V280h1.5v-9.6H279a76.7,76.7,0,0,1-1.7,9.5l1,.2C282.9,261.3,279.6,248.2,275.9,240.6Zm-8-9.8a36.8,36.8,0,0,1,7.1,10.3,43.7,43.7,0,0,1,2.2,5.6h-9.3Zm9.5,16.5a59.2,59.2,0,0,1,2,10.9H267.9V247.3Zm1.7,22.4H267.9V258.9h11.5A57.4,57.4,0,0,1,279.1,269.7Z",
    transform: "translate(0 -55)"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M267.6,246.3c0,.3-.9.5-2,.5s-2.1-.2-2.1-.5.9-.5,2.1-.5S267.6,246,267.6,246.3Z",
    transform: "translate(0 -55)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M267.6,246.3c0,.3-.9.5-2,.5s-2.1-.2-2.1-.5.9-.5,2.1-.5S267.6,246,267.6,246.3Z",
    transform: "translate(0 -55)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M265.6,246.6l-1.6-.2c-.1-.1-.1-.2,0-.2l1.6-.2,1.6.2v.2Z",
    transform: "translate(0 -55)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M262.5,224.2H283a.3.3,0,0,1,.3.3V226a0,0,0,0,1,0,0H262.2a0,0,0,0,1,0,0v-1.5A.3.3,0,0,1,262.5,224.2Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M262.5,224.2H283a.3.3,0,0,1,.3.3V226a0,0,0,0,1,0,0H262.2a0,0,0,0,1,0,0v-1.5A.3.3,0,0,1,262.5,224.2Z"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "284 225.6 261.5 225.6 260.5 226.2 260.5 226.4 285 226.4 285 226.2 284 225.6"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "284 225.6 261.5 225.6 260.5 226.2 260.5 226.4 285 226.4 285 226.2 284 225.6"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 260.2,
    y: 281.3,
    width: 42.8,
    height: 1.54,
    transform: "translate(563.3 509.2) rotate(180)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M292.9,275.9v.8h-6.4V276l3.8-3.7a3,3,0,0,0,1.2-2.3c0-1-.8-1.7-2.2-1.7a3.3,3.3,0,0,0-2.4,1l-.7-.5a3.8,3.8,0,0,1,3.2-1.3c1.9,0,3.1.9,3.1,2.4a3.9,3.9,0,0,1-1.5,2.9l-3.2,3.1Z",
    transform: "translate(0 -55)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M300.3,274c0,1.6-1.1,2.8-3.4,2.8a4.6,4.6,0,0,1-3.2-1.2l.4-.8a3.6,3.6,0,0,0,2.8,1.1c1.6,0,2.4-.8,2.4-1.9s-.7-1.9-3.1-1.9h-1.9l.5-4.6h5v.9h-4.2l-.3,2.9h1.2C299.2,271.3,300.3,272.4,300.3,274Z",
    transform: "translate(0 -55)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.4,235.4a11.2,11.2,0,0,1-21.5,6.4,11.1,11.1,0,0,1,7.5-13.9A11.2,11.2,0,0,1,293.4,235.4Z",
    transform: "translate(0 -55)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M289.1,244.8a9,9,0,0,1-13-12.4,9.1,9.1,0,0,1,12.7-.3A9,9,0,0,1,289.1,244.8Z",
    transform: "translate(0 -55)"
  }))), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 173.6,
    y: 365,
    width: 16.1,
    height: 27.38,
    transform: "translate(-233.6 387.2) rotate(-73.1)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "w",
    x: 173.6,
    y: 365,
    width: 16.1,
    height: 27.38,
    transform: "translate(-233.6 387.2) rotate(-73.1)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 178,
    y: 371,
    width: 3.7,
    height: 27.38,
    transform: "translate(-240.5 389.6) rotate(-73.1)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 121.2,
    cy: 358.6,
    r: 50,
    transform: "translate(-218.1 135.8) rotate(-45)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 121.2,
    cy: 358.6,
    r: 50,
    transform: "translate(-218.1 135.8) rotate(-45)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M68.8,346.9a53.7,53.7,0,1,0,67.1-35.8A53.7,53.7,0,0,0,68.8,346.9Zm96.7,29.4A47.4,47.4,0,1,1,134,317.2,47.2,47.2,0,0,1,165.5,376.3Z",
    transform: "translate(0 -55)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M68.8,346.9a53.7,53.7,0,1,0,67.1-35.8A53.7,53.7,0,0,0,68.8,346.9Zm96.7,29.4A47.4,47.4,0,1,1,134,317.2,47.2,47.2,0,0,1,165.5,376.3Z",
    transform: "translate(0 -55)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M70.2,342.2a53.7,53.7,0,1,0,67.1-35.7A53.9,53.9,0,0,0,70.2,342.2Zm96.7,29.5a47.4,47.4,0,1,1-31.5-59.1A47.4,47.4,0,0,1,166.9,371.7Z",
    transform: "translate(0 -55)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M70.2,342.2a53.7,53.7,0,1,0,67.1-35.7A53.9,53.9,0,0,0,70.2,342.2Zm96.7,29.5a47.4,47.4,0,1,1-31.5-59.1A47.4,47.4,0,0,1,166.9,371.7Z",
    transform: "translate(0 -55)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M281.2,409h0a10.8,10.8,0,0,1-13.4,7.2l-77.2-23.5a3.6,3.6,0,0,1-2.3-4.4l4.2-13.9a3.6,3.6,0,0,1,4.4-2.3L274,395.6A10.7,10.7,0,0,1,281.2,409Z",
    transform: "translate(0 -55)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M281.2,409h0a10.8,10.8,0,0,1-13.4,7.2l-77.2-23.5a3.6,3.6,0,0,1-2.3-4.4l4.2-13.9a3.6,3.6,0,0,1,4.4-2.3L274,395.6A10.7,10.7,0,0,1,281.2,409Z",
    transform: "translate(0 -55)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M281.6,407.2a11.6,11.6,0,0,1-.4,1.8,10.8,10.8,0,0,1-13.4,7.2l-77.2-23.5a3.6,3.6,0,0,1-2.3-4.4l1.1-3.5a3.5,3.5,0,0,0,2.3,4.4l77.1,23.5A10.9,10.9,0,0,0,281.6,407.2Z",
    transform: "translate(0 -55)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M273.4,401.1c2.1.7,3.4,2.7,2.9,4.5a3.8,3.8,0,0,1-4.9,2.1c-2.2-.6-3.5-2.6-2.9-4.5S271.2,400.5,273.4,401.1Z",
    transform: "translate(0 -55)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M105.7,329.3c4.7,3.2,5.1,10.8.9,17s-11.4,8.5-16.1,5.3-5.2-10.8-1-17S101,326.1,105.7,329.3Z",
    transform: "translate(0 -55)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M113.1,348.3c1,.6,1.1,2.2.2,3.5s-2.4,1.8-3.4,1.1-1.1-2.2-.2-3.5S112.1,347.6,113.1,348.3Z",
    transform: "translate(0 -55)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M378.4,245.4l-.8,8.5,7.4-.5s1.4-5.9-2.7-8.7Z",
    transform: "translate(0 -55)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "379.2 202 385.4 202.8 385 198.4 377.6 198.9 379.2 202"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M384.5,202l1.5,1.1,1.3,1.1,2.5,2.4a53.4,53.4,0,0,1,4.6,5,44.9,44.9,0,0,1,4,5.7l.9,1.5.4.7.2.4.3.6a10.1,10.1,0,0,1,1.2,5.1,13.4,13.4,0,0,1-.9,4.6,16.6,16.6,0,0,1-1.9,3.5,28.3,28.3,0,0,1-4.7,5.5,56.3,56.3,0,0,1-11,7.8,2.6,2.6,0,0,1-3.4-1,2.5,2.5,0,0,1,.5-3.1h.1a76.3,76.3,0,0,0,8.4-8.7,24.1,24.1,0,0,0,3-4.6,6.5,6.5,0,0,0,1-3.8,1.4,1.4,0,0,0-.3-.9l-.8-1.1a7.6,7.6,0,0,0-.8-1.1,53.2,53.2,0,0,0-3.8-4.5c-1.3-1.4-2.6-2.8-4.1-4.2l-2.1-1.9-1.1-1-1-.8-.2-.2a5.1,5.1,0,0,1,6.2-8Z",
    transform: "translate(0 -55)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M395.2,209.4l-9.3,12a34,34,0,0,1-4.4-2.5,27.9,27.9,0,0,1-7.9-7.1,8.5,8.5,0,0,1-1.7-6.4c1.2-6.5,5.7-10.2,9.6-9.4S395.2,209.4,395.2,209.4Z",
    transform: "translate(0 -55)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M381.5,218.9a27.9,27.9,0,0,1-7.9-7.1c1.6-3.8,2.9-6.6,2.9-6.6A24.5,24.5,0,0,1,381.5,218.9Z",
    transform: "translate(0 -55)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M354.7,171.4c-.1.5-.4.8-.8.7s-.5-.5-.4-1,.5-.8.8-.7S354.8,170.9,354.7,171.4Z",
    transform: "translate(0 -55)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M354.3,172.2a17.4,17.4,0,0,1-3.2,3.8,2.9,2.9,0,0,0,2.3.9Z",
    transform: "translate(0 -55)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M357.1,169h.2a.3.3,0,0,0,0-.4,3,3,0,0,0-2.5-1,.3.3,0,0,0-.3.3c.1.2.2.3.4.3h0a2.3,2.3,0,0,1,2,.8Z",
    transform: "translate(0 -55)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M368.9,178.4c-.9,4.5-1.8,13,1.4,16,0,0-1.3,4.7-9.8,4.7s-4.5-4.7-4.5-4.7c5.1-1.2,5-5,4.1-8.6Z",
    transform: "translate(0 -55)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M372.1,195.3c.7-1.3,1.5-2.8-.1-3.2s-12.8-1.4-16-.5c1,1.8-.7,4-.7,4Z",
    transform: "translate(0 -55)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M371.5,173.7c-1.6,6-2.3,9.6-6,12.1-5.6,3.8-12.5-.5-12.8-6.9s2.5-14.6,9-15.9A8.5,8.5,0,0,1,371.5,173.7Z",
    transform: "translate(0 -55)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M372.1,195.3c.7-1.3,1.5-2.8-.1-3.2s-12.8-1.4-16-.5c1,1.8-.7,4-.7,4Z",
    transform: "translate(0 -55)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M401.5,409c0-.1.1-.1.1-.2h-.1c-.1,0-2-.8-2.9-.4a.8.8,0,0,0-.4.4c-.1.4,0,.6.2.7s.9.2,1.5.1Zm-.5-.2c-.8.4-2.1.7-2.4.4s-.2-.1-.1-.4.1-.2.2-.3h.2A5.1,5.1,0,0,1,401,408.8Z",
    transform: "translate(0 -55)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M401.5,408.9h.1c-.1-.1-.6-1.8-1.4-2.3a.9.9,0,0,0-.7,0,.5.5,0,0,0-.4.5c.1.7,1.6,1.8,2.3,2h.1Zm-1.5-2.1c.6.3,1,1.3,1.2,1.8s-1.8-1.2-1.8-1.6,0-.2.2-.2h.1A.2.2,0,0,1,400,406.8Z",
    transform: "translate(0 -55)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M355.5,410.4c0-.1.1-.1.1-.2h-.1c-.1-.1-2.3-1.3-3.3-1a.5.5,0,0,0-.5.3.8.8,0,0,0,0,.7,3.2,3.2,0,0,0,1.9.4Zm-.5-.3c-1.2.2-2.8.2-3-.2a.2.2,0,0,1,0-.3c0-.1.1-.2.3-.2h.3A6.8,6.8,0,0,1,355,410.1Z",
    transform: "translate(0 -55)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M355.5,410.3c.1,0,.1,0,.1-.1a4,4,0,0,0-1-2.4,1.1,1.1,0,0,0-.8-.3c-.4.1-.5.3-.5.4s1.3,2.1,2.1,2.5h.1Zm-1.1-2.3c.6.4.8,1.5.9,1.9s-1.8-1.5-1.8-1.9.1-.2.3-.2h.1Z",
    transform: "translate(0 -55)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "362.4 355.3 356.1 355.3 355.5 340.7 361.7 340.7 362.4 355.3"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "408.5 352.4 402.3 353.7 396.2 340.1 402.3 338.8 408.5 352.4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M401.7,408l6.9-1.5a.6.6,0,0,1,.6.3l2.4,5.2a.9.9,0,0,1-.6,1.3l-6.7,1.3-8.6,1.9c-2.5.6-3.5-1.9-2.5-2.3,4.5-2.1,6.4-3.9,7.6-5.6A1.8,1.8,0,0,1,401.7,408Z",
    transform: "translate(0 -55)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M356.1,409.5H363c.2,0,.5.2.5.4l1.3,5.6a1,1,0,0,1-.9,1.1l-9.2-.2-11,.2c-2.6,0-3.3-2.6-2.3-2.8,5-1.1,9-1.2,13.2-3.8A3,3,0,0,1,356.1,409.5Z",
    transform: "translate(0 -55)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M346.3,196.2s-6.7,7.5-.3,54.3h33.5c.3-5.2-3-30.4,2-54.6a85.4,85.4,0,0,0-11.2-1.5,136.3,136.3,0,0,0-14.3,0A66.1,66.1,0,0,0,346.3,196.2Z",
    transform: "translate(0 -55)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M343.3,218.4c2.8-3,7.7-8.9,7.2-13.8l-6.3-1.5A82.3,82.3,0,0,0,343.3,218.4Z",
    transform: "translate(0 -55)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "355.5 340.7 355.8 348.2 362.1 348.2 361.7 340.7 355.5 340.7"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "402.3 338.8 396.2 340.1 399.3 347.1 405.5 345.8 402.3 338.8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M357.9,250.5a4.2,4.2,0,0,0,.1.7c.1.6.2,1.4.4,2.5,1.2,7.9,4.3,28.6,7.2,45.3,1.2,6.9,2.4,13.1,3.3,17.4,4.3,19.7,27.3,84.9,27.3,84.9l11.2-2.5s-16.1-53-19.7-80.6c-2.3-17.7-6.5-53.5-7.8-64.5-.1-1.1-.2-1.9-.3-2.5v-.7Z",
    transform: "translate(0 -55)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M393.5,397.5c-.1,0,2.1,4.1,2.1,4.1l12.6-2.8-1-3.8Z",
    transform: "translate(0 -55)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M362.4,267.6c8.2,1.6,7.3,32.3,6.4,48.1-2.4-11.2-5.9-32.7-8.3-47.9A2.5,2.5,0,0,1,362.4,267.6Z",
    transform: "translate(0 -55)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M345.8,316.6c.7,19.9,7.6,85.1,7.6,85.1h10.7s.4-64,.8-83.6c.2-5.2.4-11.9.7-19h0c.8-17.4,1.8-37.5,2.3-45.3,0-1.1.1-1.9.1-2.5v-.7H346a1.7,1.7,0,0,0-.1.7v2.5C345.7,264.7,345.2,300.5,345.8,316.6Z",
    transform: "translate(0 -55)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M351.4,397.5c-.1,0,.6,4.4.6,4.4h12.9l.4-3.9Z",
    transform: "translate(0 -55)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M346,209.2a57.9,57.9,0,0,1-6.3-1.9c-2-.7-4.1-1.5-6.1-2.4l-5.9-2.8a48.8,48.8,0,0,1-5.8-3.4l-2.8-2.1-2.6-2.4a52.1,52.1,0,0,1-4.5-5,71.5,71.5,0,0,1-6.7-11.3l4.3-2.6c2.6,3,5.4,6,8.2,8.7a43.5,43.5,0,0,0,9,6.8,85.3,85.3,0,0,0,10.6,4.8l5.7,2c1.8.7,3.8,1.3,5.6,1.8Z",
    transform: "translate(0 -55)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M349.1,210.2c-6,6.2-21.2-2.3-21.2-2.3l4.5-14.5a78.9,78.9,0,0,1,15.8,2C357.5,197.7,353.7,205.5,349.1,210.2Z",
    transform: "translate(0 -55)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M310.7,176.8l-4.2-7.4-5.8,4.7s2.3,5.6,7.2,5.5Z",
    transform: "translate(0 -55)"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "303.4 112.9 297.9 115.8 300.7 119.2 306.5 114.5 303.4 112.9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M393.5,397.5c-.1,0,2.1,4.1,2.1,4.1l12.6-2.8-1-3.8Z",
    transform: "translate(0 -55)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M351.4,397.5c-.1,0,.6,4.4.6,4.4h12.9l.4-3.9Z",
    transform: "translate(0 -55)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 363.8,
    y: 251.2,
    width: 11.7,
    height: 2.5,
    transform: "translate(739.3 450) rotate(180)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 351.3,
    y: 251.2,
    width: 10.9,
    height: 2.5,
    transform: "translate(713.5 450) rotate(180)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5,251.2v2.5h3.4c-.1-1.1-.2-1.9-.3-2.5Z",
    transform: "translate(0 -55)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9,253.7h4.4v-2.5h-4.4Z",
    transform: "translate(0 -55)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M357.4,173.2l1.3-3.6a3.6,3.6,0,0,1-.7-3,2.3,2.3,0,0,0-.7,1.9s-2.2-1.1-1.3-4.3a3.9,3.9,0,0,0-1.3,2.6s-1.9-4.1,2.7-6.3,10.6-1.5,14.4.7a5.5,5.5,0,0,1,2.8,5,2.8,2.8,0,0,1,1.7,2c.9,3.6-.1,12.6-8.2,16.6C368.1,184.8,359.6,183.9,357.4,173.2Z",
    transform: "translate(0 -55)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M361.2,173.9a6.9,6.9,0,0,1-2.5,3.8c-1.6,1.2-2.9,0-2.7-1.8s1-4.4,2.8-4.8S361.7,172.1,361.2,173.9Z",
    transform: "translate(0 -55)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,197.1a44.6,44.6,0,0,1,1.9,12.5l-.7,12.6c-.2,4.2-.4,8.4-.5,12.6-.1,2.1-.1,4.2-.1,6.3a42.2,42.2,0,0,0,.3,6.2,86.5,86.5,0,0,1-.6-12.5c0-4.2.2-8.4.4-12.6s.5-8.4.8-12.6a44.3,44.3,0,0,0-.3-6.3C368.9,201.2,368.5,199.2,368,197.1Z",
    transform: "translate(0 -55)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.154f1af7b63834ca7cfea206d216ebce.svg";
export { ForwardRef as ReactComponent };